import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

export type AccessPermission = {
  __typename?: 'AccessPermission';
  cancel: Scalars['Boolean']['output'];
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
  view_self: Scalars['Boolean']['output'];
};

export type AccessPermissionInput = {
  cancel: Scalars['Boolean']['input'];
  create: Scalars['Boolean']['input'];
  delete: Scalars['Boolean']['input'];
  update: Scalars['Boolean']['input'];
  view: Scalars['Boolean']['input'];
  view_self: Scalars['Boolean']['input'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  CashSales = 'cash_sales',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  User = 'user',
  Vendor = 'vendor'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  Image = 'image',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent',
  Promotion = 'promotion'
}

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type ApprovalProgress = {
  __typename?: 'ApprovalProgress';
  approval_template?: Maybe<ApprovalTemplate>;
  approval_template_id: Scalars['Int']['output'];
  approver: User;
  approver_id: Scalars['Int']['output'];
  created_date: Scalars['DateTime']['output'];
  document_id: Scalars['Int']['output'];
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalTemplate = {
  __typename?: 'ApprovalTemplate';
  approver_id_list?: Maybe<Array<Scalars['String']['output']>>;
  approver_list?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  required_approval: Scalars['Int']['output'];
  step_number: Scalars['Int']['output'];
  workflow_document_type: Scalars['String']['output'];
  workflow_step_number: Scalars['Int']['output'];
  workflow_template?: Maybe<WorkflowTemplate>;
};

export enum AvailableFor {
  Erp = 'erp',
  ErpPos = 'erp_pos'
}

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type Branch = {
  __typename?: 'Branch';
  address: Scalars['Json']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_hq: Scalars['Boolean']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  short_name: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  unique_id: Scalars['String']['output'];
  user_id_list: Array<Scalars['Int']['output']>;
  user_list?: Maybe<Array<Maybe<BranchUser>>>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type BranchUser = {
  __typename?: 'BranchUser';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type BundleItemDetail = {
  __typename?: 'BundleItemDetail';
  bundle_item: Item;
  bundle_item_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item: Item;
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Int']['output'];
  ratio_percentage?: Maybe<Scalars['Float']['output']>;
  sku_desc?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  sorting_order?: Maybe<Scalars['Int']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
};

export type BundleItemDetailCreateInput = {
  item_unique_id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Int']['input'];
  ratio_percentage?: InputMaybe<Scalars['Float']['input']>;
  sku_name: Scalars['String']['input'];
  special_price?: InputMaybe<Scalars['Float']['input']>;
};

export type BundleItemDetailUniqueInput = {
  id: Scalars['Int']['input'];
};

export type BundleItemDetailUpdateInput = {
  item_unique_id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  ratio_percentage?: InputMaybe<Scalars['Float']['input']>;
  sku_name?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
};

export type BundleItemImportDataInput = {
  item_sku_name: Scalars['String']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  ratio_percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CashSales = {
  __typename?: 'CashSales';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  promotion_list?: Maybe<Array<PromotionAppliedLog>>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum CouponType {
  ManyTime = 'many_time',
  OneTime = 'one_time'
}

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockByBranchReportView = {
  __typename?: 'CurrentStockByBranchReportView';
  available_qty: Scalars['Int']['output'];
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name: Scalars['String']['output'];
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty: Scalars['Int']['output'];
  sale_committed_qty: Scalars['Int']['output'];
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty: Scalars['Int']['output'];
  transit_qty: Scalars['Int']['output'];
  unique_id: Scalars['String']['output'];
};

export type CurrentStockByBranchReportViewAggrid = {
  __typename?: 'CurrentStockByBranchReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockByBranchReportView>>;
};

export type CurrentStockByLocationReportView = {
  __typename?: 'CurrentStockByLocationReportView';
  available_qty?: Maybe<Scalars['Int']['output']>;
  bin_location_id?: Maybe<Scalars['Int']['output']>;
  bin_name?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  transit_qty?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockByLocationReportViewAggrid = {
  __typename?: 'CurrentStockByLocationReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockByLocationReportView>>;
};

export type CurrentStockByLotReportView = {
  __typename?: 'CurrentStockByLotReportView';
  available_qty?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bin_location_id?: Maybe<Scalars['Int']['output']>;
  bin_location_name?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  transit_qty?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockByLotReportViewAggrid = {
  __typename?: 'CurrentStockByLotReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockByLotReportView>>;
};

export type CurrentStockBySnReportView = {
  __typename?: 'CurrentStockBySNReportView';
  barcode?: Maybe<Scalars['String']['output']>;
  bin_id?: Maybe<Scalars['Int']['output']>;
  bin_name?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_main_category?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockBySnReportViewAggrid = {
  __typename?: 'CurrentStockBySNReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockBySnReportView>>;
};

export type CurrentStockByWarehouseReportView = {
  __typename?: 'CurrentStockByWarehouseReportView';
  available_qty?: Maybe<Scalars['Int']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  max_stock_qty?: Maybe<Scalars['Int']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Int']['output']>;
  min_stock_qty?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  reorder_point?: Maybe<Scalars['Int']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  transit_qty?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockByWarehouseReportViewAggrid = {
  __typename?: 'CurrentStockByWarehouseReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockByWarehouseReportView>>;
};

export type CustomerDeposit = {
  __typename?: 'CustomerDeposit';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deposit_list?: Maybe<Array<CustomerDepositItem>>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remaining_deposit_amount?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerDepositItem = {
  __typename?: 'CustomerDepositItem';
  customer_deposit?: Maybe<CustomerDeposit>;
  customer_deposit_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export enum CustomerEligibility {
  All = 'all',
  SpecificCustomers = 'specific_customers',
  SpecificGroups = 'specific_groups'
}

export type DeliveryAttribute = {
  __typename?: 'DeliveryAttribute';
  height?: Maybe<Scalars['Float']['output']>;
  height_uom?: Maybe<Unit>;
  height_uom_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  item: Item;
  item_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  length_uom?: Maybe<Unit>;
  length_uom_id?: Maybe<Scalars['Int']['output']>;
  thick?: Maybe<Scalars['Float']['output']>;
  thick_uom?: Maybe<Unit>;
  thick_uom_id?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  volume_uom?: Maybe<Unit>;
  volume_uom_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_uom?: Maybe<Unit>;
  weight_uom_id?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  width_uom?: Maybe<Unit>;
  width_uom_id?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryAttributeCreateOrUpdateFromImporterInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  height_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  thick?: InputMaybe<Scalars['Float']['input']>;
  thick_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  volume_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryAttributeCreateOrUpdateInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  height_uom_id?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_uom_id?: InputMaybe<Scalars['Int']['input']>;
  thick?: InputMaybe<Scalars['Float']['input']>;
  thick_uom_id?: InputMaybe<Scalars['Int']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  volume_uom_id?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weight_uom_id?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_detail?: Maybe<Scalars['Json']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  exported_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<ReferenceSalesDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  tracking_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ExportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  report_type: InventoryExportType;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum GenderType {
  Female = 'female',
  Male = 'male'
}

export type GoodsAdjust = {
  __typename?: 'GoodsAdjust';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_id: Scalars['Int']['output'];
  workflow_step: Scalars['Int']['output'];
};

export type GoodsAdjustCreateInput = {
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  warehouse_id: Scalars['Int']['input'];
  workflow_step?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsAdjustReportView = {
  __typename?: 'GoodsAdjustReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by_name?: Maybe<Scalars['String']['output']>;
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type GoodsAdjustReportViewAggrid = {
  __typename?: 'GoodsAdjustReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<GoodsAdjustReportView>>;
};

export type GoodsAdjustUpdateInput = {
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  workflow_step?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsAdjustView = {
  __typename?: 'GoodsAdjustView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch_id: Scalars['Int']['output'];
  branch_name: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_name: Scalars['String']['output'];
};

export type GoodsAdjustViewAggrid = {
  __typename?: 'GoodsAdjustViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsAdjustView>;
};

export type GoodsAdjustWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsIssue = {
  __typename?: 'GoodsIssue';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export type GoodsIssueAggrid = {
  __typename?: 'GoodsIssueAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsIssue>;
};

export type GoodsIssueCreateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  trace_entry_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsIssueReportView = {
  __typename?: 'GoodsIssueReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_qty?: Maybe<Scalars['Int']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  pending_qty?: Maybe<Scalars['Int']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  posted_qty?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by_name?: Maybe<Scalars['String']['output']>;
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type GoodsIssueReportViewAggrid = {
  __typename?: 'GoodsIssueReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<GoodsIssueReportView>>;
};

export type GoodsIssueUpdateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  trace_entry_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsIssueView = {
  __typename?: 'GoodsIssueView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  main_status?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_name?: Maybe<Scalars['String']['output']>;
};

export type GoodsIssueViewAggrid = {
  __typename?: 'GoodsIssueViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsIssueView>;
};

export type GoodsIssueWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsReceive = {
  __typename?: 'GoodsReceive';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id_list: Array<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export type GoodsReceiveAggrid = {
  __typename?: 'GoodsReceiveAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsReceive>;
};

export type GoodsReceiveCreateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsReceiveReportView = {
  __typename?: 'GoodsReceiveReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  po_reference_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by_name?: Maybe<Scalars['String']['output']>;
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  scanned_status?: Maybe<Scalars['Boolean']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type GoodsReceiveReportViewAggrid = {
  __typename?: 'GoodsReceiveReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<GoodsReceiveReportView>>;
};

export type GoodsReceiveUpdateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsReceiveView = {
  __typename?: 'GoodsReceiveView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  main_status?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_name?: Maybe<Scalars['String']['output']>;
};

export type GoodsReceiveViewAggrid = {
  __typename?: 'GoodsReceiveViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsReceiveView>;
};

export type GoodsReceiveWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsReturn = {
  __typename?: 'GoodsReturn';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export type GoodsReturnAggrid = {
  __typename?: 'GoodsReturnAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsReturn>;
};

export type GoodsReturnCreateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsReturnReportView = {
  __typename?: 'GoodsReturnReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_qty?: Maybe<Scalars['Int']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  pending_qty?: Maybe<Scalars['Int']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  posted_qty?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by_name?: Maybe<Scalars['String']['output']>;
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type GoodsReturnReportViewAggrid = {
  __typename?: 'GoodsReturnReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<GoodsReturnReportView>>;
};

export type GoodsReturnUpdateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsReturnView = {
  __typename?: 'GoodsReturnView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  main_status?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  warehouse_name?: Maybe<Scalars['String']['output']>;
};

export type GoodsReturnViewAggrid = {
  __typename?: 'GoodsReturnViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsReturnView>;
};

export type GoodsReturnWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsTransfer = {
  __typename?: 'GoodsTransfer';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  consignment_bin_location_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  destination_branch: Branch;
  destination_branch_id: Scalars['Int']['output'];
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  source_branch: Branch;
  source_branch_id: Scalars['Int']['output'];
  source_warehouse?: Maybe<Warehouse>;
  source_warehouse_id?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type GoodsTransferAggrid = {
  __typename?: 'GoodsTransferAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsTransfer>;
};

export type GoodsTransferCreateInput = {
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  consignment_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  created_by?: InputMaybe<CreatorInputObject>;
  destination_branch_id: Scalars['Int']['input'];
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  source_branch_id: Scalars['Int']['input'];
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
};

export type GoodsTransferReportView = {
  __typename?: 'GoodsTransferReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_bin_location_name?: Maybe<Scalars['String']['output']>;
  destination_branch_id?: Maybe<Scalars['Int']['output']>;
  destination_branch_name?: Maybe<Scalars['String']['output']>;
  destination_branch_unique_id?: Maybe<Scalars['String']['output']>;
  destination_scanned_by_name?: Maybe<Scalars['String']['output']>;
  destination_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  destination_scanned_status?: Maybe<Scalars['Boolean']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  source_branch_id?: Maybe<Scalars['Int']['output']>;
  source_branch_name?: Maybe<Scalars['String']['output']>;
  source_branch_unique_id?: Maybe<Scalars['String']['output']>;
  source_scanned_by_name?: Maybe<Scalars['String']['output']>;
  source_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
};

export type GoodsTransferReportViewAggrid = {
  __typename?: 'GoodsTransferReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<GoodsTransferReportView>>;
};

export type GoodsTransferUpdateInput = {
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  consignment_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_branch_id?: InputMaybe<Scalars['Int']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  source_branch_id?: InputMaybe<Scalars['Int']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsTransferView = {
  __typename?: 'GoodsTransferView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  destination_branch_id: Scalars['Int']['output'];
  destination_branch_name: Scalars['String']['output'];
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_branch_id: Scalars['Int']['output'];
  source_branch_name: Scalars['String']['output'];
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type GoodsTransferViewAggrid = {
  __typename?: 'GoodsTransferViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsTransferView>;
};

export type GoodsTransferWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryDocumentCancelOutput = {
  __typename?: 'InventoryDocumentCancelOutput';
  flag_status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unique_id: Scalars['String']['output'];
};

export type InventoryDocumentCancelPendingScanOutput = {
  __typename?: 'InventoryDocumentCancelPendingScanOutput';
  unique_id: Scalars['String']['output'];
};

export enum InventoryDocumentType {
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer'
}

export enum InventoryExportType {
  BundleItem = 'bundle_item',
  ItemBundle = 'item_bundle',
  ItemNormal = 'item_normal',
  ItemPriceList = 'item_price_list',
  ItemVariant = 'item_variant',
  Service = 'service',
  VariantSku = 'variant_sku'
}

export type InventoryImportInput = {
  data: Array<Scalars['Any']['input']>;
  import_mode: InventoryImportMode;
  import_type: InventoryImportType;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export enum InventoryImportMode {
  Create = 'create',
  Update = 'update'
}

export type InventoryImportResult = {
  __typename?: 'InventoryImportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  jobId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum InventoryImportType {
  Images = 'images',
  ItemBundle = 'item_bundle',
  ItemInBundle = 'item_in_bundle',
  ItemNormal = 'item_normal',
  ItemPriceListAll = 'item_price_list_all',
  ItemPriceListByItem = 'item_price_list_by_item',
  ItemStockLimit = 'item_stock_limit',
  ItemVariant = 'item_variant',
  ItemVariantPrice = 'item_variant_price',
  ItemVariantValue = 'item_variant_value',
  Service = 'service'
}

export type InventoryReferenceLineItem = {
  __typename?: 'InventoryReferenceLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type InventoryReferenceLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export enum InventoryReportType {
  CurrentStockByBranch = 'current_stock_by_branch',
  CurrentStockByLocation = 'current_stock_by_location',
  CurrentStockByLot = 'current_stock_by_lot',
  CurrentStockBySn = 'current_stock_by_sn',
  CurrentStockByWarehouse = 'current_stock_by_warehouse',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  NoTraceEntry = 'no_trace_entry',
  TraceEntry = 'trace_entry',
  UnscannedSn = 'unscanned_sn'
}

export enum InventorySubscriptionType {
  Export = 'export',
  Import = 'import',
  Report = 'report'
}

export type Item = {
  __typename?: 'Item';
  attribute_list: Array<Scalars['Json']['output']>;
  barcode: Scalars['String']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  category_group?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date: Scalars['DateTime']['output'];
  customer_insurance_duration?: Maybe<Scalars['Int']['output']>;
  deliver_uom?: Maybe<Unit>;
  deliver_uom_id?: Maybe<Scalars['Int']['output']>;
  delivery_attribute?: Maybe<DeliveryAttribute>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_detail?: Maybe<Scalars['String']['output']>;
  insurance_name?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Int']['output'];
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  item_variant_key_list: Array<ItemVariantKey>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  max_stock_qty?: Maybe<Scalars['Float']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Int']['output']>;
  min_stock_qty?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pre_sale?: Maybe<Scalars['Boolean']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom?: Maybe<Unit>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  reorder_point?: Maybe<Scalars['Float']['output']>;
  replenishment_stock?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom?: Maybe<Unit>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  seller_insurance_duration?: Maybe<Scalars['Int']['output']>;
  seller_unique_id: Scalars['String']['output'];
  selling_point_list: Array<Scalars['Json']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  set_attribute?: Maybe<Scalars['Json']['output']>;
  sku_detail_list: Array<ItemSkuDetail>;
  sku_list: Array<ItemSkuValue>;
  special_price?: Maybe<Scalars['Float']['output']>;
  stock_uom?: Maybe<Unit>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  tag_id_list: Array<Scalars['Int']['output']>;
  tag_list: Array<Tag>;
  tracability?: Maybe<Tracability>;
  type?: Maybe<ItemType>;
  unique_id: Scalars['String']['output'];
  uom_group?: Maybe<UomGroup>;
  uom_group_id?: Maybe<Scalars['Int']['output']>;
  vendor_contact?: Maybe<Scalars['Json']['output']>;
};

export type ItemAdjustment = {
  __typename?: 'ItemAdjustment';
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  current_price?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
};

export type ItemAdjustmentCreateInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  current_price?: InputMaybe<Scalars['Float']['input']>;
  item_name: Scalars['String']['input'];
  item_price_list_id: Scalars['Int']['input'];
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
};

export type ItemAdjustmentCreateWithoutItemPriceListInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  current_price?: InputMaybe<Scalars['Float']['input']>;
  item_name: Scalars['String']['input'];
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
};

export type ItemAdjustmentUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemAdjustmentUpdateInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  current_price?: InputMaybe<Scalars['Float']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  sku_name?: InputMaybe<Scalars['String']['input']>;
};

export type ItemAdjustmentUpdateWithoutItemPriceListInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  current_price?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_name: Scalars['String']['input'];
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
};

export type ItemBundleImportDataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  delivery_attribute?: InputMaybe<DeliveryAttributeCreateOrUpdateFromImporterInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id: Scalars['String']['input'];
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  sku_name?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  tag_name_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  unique_id: Scalars['String']['input'];
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemBundleImportInput = {
  data: Array<ItemBundleImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemCreateDirectInput = {
  attribute_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  barcode: Scalars['String']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  bundle_item_detail_list?: InputMaybe<Array<BundleItemDetailCreateInput>>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_id?: InputMaybe<Scalars['Int']['input']>;
  delivery_attribute?: InputMaybe<DeliveryAttributeCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  item_variant_key_list?: InputMaybe<Array<ItemVariantKeyWithoutItemInput>>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_id?: InputMaybe<Scalars['Int']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_id?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id: Scalars['String']['input'];
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  set_attribute?: InputMaybe<Scalars['Json']['input']>;
  sku_list?: InputMaybe<Array<ItemSkuDetailCreateItemDirectInput>>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_id?: InputMaybe<Scalars['Int']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  type?: InputMaybe<ItemType>;
  unique_id: Scalars['String']['input'];
  uom_group?: InputMaybe<ItemUomGroupCreateBaseUnitInput>;
  uom_group_id?: InputMaybe<Scalars['Int']['input']>;
  vendor_contact?: InputMaybe<Scalars['Json']['input']>;
};

export type ItemDeleteOutput = {
  __typename?: 'ItemDeleteOutput';
  active_document_list?: Maybe<Array<Scalars['String']['output']>>;
  is_deletable?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Item>;
};

export type ItemImageImportDataInput = {
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_unique_id: Scalars['String']['input'];
};

export type ItemImageImportInput = {
  data: Array<ItemImageImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemInBundleImportDataInput = {
  bundle_item_detail_list: Array<BundleItemImportDataInput>;
  item_unique_id: Scalars['String']['input'];
};

export type ItemInBundleImportInput = {
  data: Array<ItemInBundleImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemInputValidateInput = {
  barcode_list?: InputMaybe<Array<Scalars['String']['input']>>;
  branch_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  brand_list?: InputMaybe<Array<Scalars['String']['input']>>;
  category_group_list?: InputMaybe<Array<Scalars['String']['input']>>;
  import_mode: InventoryImportMode;
  item_name_list?: InputMaybe<Array<Scalars['String']['input']>>;
  item_price_list_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  item_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  main_category_list?: InputMaybe<Array<Scalars['String']['input']>>;
  model_list?: InputMaybe<Array<Scalars['String']['input']>>;
  sales_channel_list?: InputMaybe<Array<Scalars['String']['input']>>;
  segment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  series_list?: InputMaybe<Array<Scalars['String']['input']>>;
  sku_name_list?: InputMaybe<Array<Scalars['String']['input']>>;
  sub_category_list?: InputMaybe<Array<Scalars['String']['input']>>;
  uom_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  vendor_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouse_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ItemNormalImportDataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  delivery_attribute?: InputMaybe<DeliveryAttributeCreateOrUpdateFromImporterInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id: Scalars['String']['input'];
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  sku_name?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  tag_name_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  unique_id: Scalars['String']['input'];
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemNormalImportInput = {
  data: Array<ItemNormalImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemPriceList = {
  __typename?: 'ItemPriceList';
  adjusted_item_list?: Maybe<Array<Maybe<ItemAdjustment>>>;
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Int']['output'];
  is_increase: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type ItemPriceListAllImportDataInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_increase?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sales_channel?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  unique_id: Scalars['String']['input'];
};

export type ItemPriceListAllImportInput = {
  data: Array<ItemPriceListAllImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemPriceListByItemImportAdjustedItemInput = {
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  sku_name: Scalars['String']['input'];
};

export type ItemPriceListByItemImportDataInput = {
  adjusted_item_list?: InputMaybe<Array<ItemPriceListByItemImportAdjustedItemInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_increase?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sales_channel?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  unique_id: Scalars['String']['input'];
};

export type ItemPriceListByItemImportInput = {
  data: Array<ItemPriceListByItemImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemPriceListCreateInput = {
  adjusted_item_list?: InputMaybe<Array<ItemAdjustmentCreateWithoutItemPriceListInput>>;
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active: Scalars['Int']['input'];
  is_increase?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type ItemPriceListFindAllInput = {
  item_name?: InputMaybe<Scalars['String']['input']>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemPriceListUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemPriceListUpdateInput = {
  adjusted_item_list?: InputMaybe<Array<ItemAdjustmentUpdateWithoutItemPriceListInput>>;
  adjusted_price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_increase?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemPriceListView = {
  __typename?: 'ItemPriceListView';
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Int']['output'];
  is_increase: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_channel_name_en?: Maybe<Scalars['String']['output']>;
  sales_channel_name_th?: Maybe<Scalars['String']['output']>;
  sales_channel_unique_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type ItemPriceListViewAggridOutput = {
  __typename?: 'ItemPriceListViewAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<ItemPriceListView>;
};

export type ItemServiceImportDataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id: Scalars['String']['input'];
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  sku_name?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  tag_name_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  unique_id: Scalars['String']['input'];
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemServiceImportInput = {
  data: Array<ItemServiceImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemSkuDetail = {
  __typename?: 'ItemSkuDetail';
  available_qty?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  item: Item;
  item_sku: ItemSkuValue;
  item_sku_qty?: Maybe<Array<ItemSkuQty>>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sku_name: Scalars['String']['output'];
  special_price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_sku_qty?: Maybe<Scalars['Json']['output']>;
};

export type ItemSkuDetailAggrid = {
  __typename?: 'ItemSkuDetailAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuDetail>;
};

export type ItemSkuDetailCreateInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sku_name: Scalars['String']['input'];
  special_price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuDetailCreateItemDirectInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_variant_value: Array<ItemVariantValueItem_Variant_Value_NameItem_Variant_Key_NameCompoundUniqueInput>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sku_name: Scalars['String']['input'];
  special_price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuDetailUniqueInput = {
  sku_name: Scalars['String']['input'];
};

export type ItemSkuDetailUpdateInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuDetailUpsertInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_variant_value: Array<ItemVariantValueItem_Variant_Value_NameItem_Variant_Key_NameCompoundUniqueInput>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sku_name: Scalars['String']['input'];
  special_price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuDetailWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ItemSkuDetailWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ItemSkuDetailWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ItemSkuDetailWhereInput>>>;
  id?: InputMaybe<Scalars['Any']['input']>;
  sku_name?: InputMaybe<Scalars['Any']['input']>;
};

export type ItemSkuQty = {
  __typename?: 'ItemSkuQty';
  available_qty: Scalars['Int']['output'];
  barcode: Scalars['String']['output'];
  bin_id?: Maybe<Scalars['Int']['output']>;
  bin_location?: Maybe<BinLocation>;
  bin_name?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty: Scalars['Int']['output'];
  sale_committed_qty: Scalars['Int']['output'];
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  stock_qty: Scalars['Int']['output'];
  transit_qty: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export type ItemSkuQtyBinNameBarcodeWhereUniqueInput = {
  barcode: Scalars['String']['input'];
  bin_id: Scalars['Int']['input'];
};

export type ItemSkuQtyByBarcodeView = {
  __typename?: 'ItemSkuQtyByBarcodeView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  bin_id: Scalars['Int']['output'];
  bin_name?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  transit_qty?: Maybe<Scalars['Float']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ItemSkuQtyByBarcodeViewAggrid = {
  __typename?: 'ItemSkuQtyByBarcodeViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByBarcodeView>;
};

export type ItemSkuQtyByBinLocationView = {
  __typename?: 'ItemSkuQtyByBinLocationView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  bin_id: Scalars['Int']['output'];
  bin_name?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  transit_qty?: Maybe<Scalars['Float']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ItemSkuQtyByBinLocationViewAggrid = {
  __typename?: 'ItemSkuQtyByBinLocationViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByBinLocationView>;
};

export type ItemSkuQtyByBranchView = {
  __typename?: 'ItemSkuQtyByBranchView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  branch_id: Scalars['Int']['output'];
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  transit_qty?: Maybe<Scalars['Float']['output']>;
};

export type ItemSkuQtyByBranchViewAggrid = {
  __typename?: 'ItemSkuQtyByBranchViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByBranchView>;
};

export type ItemSkuQtyBySkuView = {
  __typename?: 'ItemSkuQtyBySkuView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sku_name: Scalars['String']['output'];
  stock_qty?: Maybe<Scalars['Float']['output']>;
  transit_qty?: Maybe<Scalars['Float']['output']>;
};

export type ItemSkuQtyByWarehouseView = {
  __typename?: 'ItemSkuQtyByWarehouseView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  transit_qty?: Maybe<Scalars['Float']['output']>;
  warehouse_id: Scalars['Int']['output'];
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ItemSkuQtyByWarehouseViewAggrid = {
  __typename?: 'ItemSkuQtyByWarehouseViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByWarehouseView>;
};

export type ItemSkuQtyCreateInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  barcode: Scalars['String']['input'];
  bin_id: Scalars['Int']['input'];
  bin_name?: InputMaybe<Scalars['String']['input']>;
  expired_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_unique_id?: InputMaybe<Scalars['String']['input']>;
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  manufactured_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  transit_qty?: InputMaybe<Scalars['Int']['input']>;
  warehouse_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuQtyFindManyInput = {
  cursor?: InputMaybe<ItemSkuQtyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ItemSkuQtyScalarFieldEnum>>>;
  include?: InputMaybe<ItemSkuQtyIncludeInput>;
  orderBy?: InputMaybe<Scalars['Any']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemSkuQtyWhereInput>;
};

export type ItemSkuQtyIncludeInput = {
  item_sku_detail?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ItemSkuQtyScalarFieldEnum {
  BinId = 'bin_id',
  Id = 'id',
  SkuName = 'sku_name',
  WarehouseId = 'warehouse_id'
}

export type ItemSkuQtyUpdateInput = {
  available_qty?: InputMaybe<Scalars['Int']['input']>;
  purchase_ordered_qty?: InputMaybe<Scalars['Int']['input']>;
  sale_committed_qty?: InputMaybe<Scalars['Int']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  transit_qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuQtyWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  barcode?: InputMaybe<Scalars['Any']['input']>;
  bin_name?: InputMaybe<Scalars['Any']['input']>;
  id?: InputMaybe<Scalars['Any']['input']>;
  item_unique_id?: InputMaybe<Scalars['Any']['input']>;
  serial_no?: InputMaybe<Scalars['Any']['input']>;
  sku_name?: InputMaybe<Scalars['Any']['input']>;
};

export type ItemSkuQtyWhereUniqueInput = {
  bin_id_barcode?: InputMaybe<ItemSkuQtyBinNameBarcodeWhereUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemSkuValue = {
  __typename?: 'ItemSkuValue';
  id: Scalars['Int']['output'];
  item?: Maybe<Item>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_variant_value: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  sku_detail?: Maybe<ItemSkuDetail>;
  sku_name: Scalars['String']['output'];
  variant_key_id: Scalars['Int']['output'];
  variant_value_id: Scalars['Int']['output'];
};

export type ItemSkuValueCreateInput = {
  item_unique_id: Scalars['String']['input'];
  sku_detail?: InputMaybe<ItemSkuDetailCreateInput>;
  sku_name: Scalars['String']['input'];
};

export type ItemSkuValueUniqueInput = {
  sku_name: Scalars['String']['input'];
};

export type ItemStockLimitImportDataInput = {
  branch_unique_id: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sku_name: Scalars['String']['input'];
  warehouse_unique_id: Scalars['String']['input'];
};

export type ItemStockLimitImportInput = {
  data: Array<ItemStockLimitImportDataInput>;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export enum ItemType {
  Bundle = 'bundle',
  Normal = 'normal',
  Service = 'service',
  Variant = 'variant'
}

export type ItemUomGroupCreateBaseUnitInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unique_id?: InputMaybe<Scalars['String']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionCreateWithoutUomGroupInput>>>;
};

export type ItemUpdateWithSkuInput = {
  attribute_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  bundle_item_detail_list?: InputMaybe<Array<BundleItemDetailCreateInput>>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_id?: InputMaybe<Scalars['Int']['input']>;
  delivery_attribute?: InputMaybe<DeliveryAttributeCreateOrUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  item_variant_key_list?: InputMaybe<Array<ItemVariantKeyWithoutItemInput>>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_id?: InputMaybe<Scalars['Int']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_id?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id?: InputMaybe<Scalars['String']['input']>;
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  set_attribute?: InputMaybe<Scalars['Json']['input']>;
  sku_list?: InputMaybe<Array<ItemSkuDetailUpsertInput>>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_id?: InputMaybe<Scalars['Int']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  type?: InputMaybe<ItemType>;
  uom_group?: InputMaybe<ItemUomGroupCreateBaseUnitInput>;
  uom_group_id?: InputMaybe<Scalars['Int']['input']>;
  vendor_contact?: InputMaybe<Scalars['Json']['input']>;
};

export type ItemValidationInput = {
  is_active: Scalars['Boolean']['input'];
  unique_id: Scalars['String']['input'];
};

export type ItemValidationResult = {
  __typename?: 'ItemValidationResult';
  item_price?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  purchase?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trace_entry?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ItemVariantImportDataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category_group?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  customer_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  deliver_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  delivery_attribute?: InputMaybe<DeliveryAttributeCreateOrUpdateFromImporterInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  inactive_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_detail?: InputMaybe<Scalars['String']['input']>;
  insurance_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Int']['input'];
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  main_category?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Int']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pre_sale?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_standard_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  reorder_point?: InputMaybe<Scalars['Float']['input']>;
  replenishment_stock?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  seller_insurance_duration?: InputMaybe<Scalars['Int']['input']>;
  seller_unique_id: Scalars['String']['input'];
  selling_point_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  series?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_unique_id?: InputMaybe<Scalars['String']['input']>;
  sub_category?: InputMaybe<Scalars['String']['input']>;
  tag_name_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tracability?: InputMaybe<Tracability>;
  unique_id: Scalars['String']['input'];
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemVariantImportInput = {
  data: Array<ItemVariantImportDataInput>;
  import_mode: InventoryImportMode;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemVariantKey = {
  __typename?: 'ItemVariantKey';
  id: Scalars['Int']['output'];
  item: Item;
  item_unique_id: Scalars['String']['output'];
  item_variant_value_list: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key_name: Scalars['String']['output'];
};

export type ItemVariantKeyByItemInput = {
  item_unique_id: Scalars['String']['input'];
};

export type ItemVariantKeyCreateInput = {
  item_unique_id: Scalars['String']['input'];
  item_variant_value_list?: InputMaybe<Array<InputMaybe<ItemVariantValueCreateWithoutKeyInput>>>;
  variant_key_name: Scalars['String']['input'];
};

export type ItemVariantKeyWithoutItemInput = {
  item_variant_value_list?: InputMaybe<Array<InputMaybe<ItemVariantValueCreateWithoutKeyInput>>>;
  variant_key_name: Scalars['String']['input'];
};

export type ItemVariantPriceImportDataInput = {
  item_unique_id: Scalars['String']['input'];
  sku_list?: InputMaybe<Array<InputMaybe<ItemVariantPriceImportSkuInput>>>;
};

export type ItemVariantPriceImportInput = {
  data: Array<ItemVariantPriceImportDataInput>;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemVariantPriceImportSkuInput = {
  sale_price: Scalars['Float']['input'];
  sku_name: Scalars['String']['input'];
};

export type ItemVariantValidateWhereInput = {
  item_unique_id: Scalars['String']['input'];
  variant_key_name: Scalars['String']['input'];
  variant_value_name: Scalars['String']['input'];
};

export type ItemVariantValue = {
  __typename?: 'ItemVariantValue';
  id: Scalars['Int']['output'];
  item_sku: Array<ItemSkuValue>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key: ItemVariantKey;
  variant_key_name: Scalars['String']['output'];
  variant_value_name: Scalars['String']['output'];
};

export type ItemVariantValueByItemInput = {
  item_unique_id: Scalars['String']['input'];
};

export type ItemVariantValueCreate = {
  item_unique_id: Scalars['String']['input'];
  variant_key_name: Scalars['String']['input'];
  variant_value_name: Scalars['String']['input'];
};

export type ItemVariantValueCreateWithoutKeyInput = {
  variant_value_name: Scalars['String']['input'];
};

export type ItemVariantValueImportDataInput = {
  item_unique_id: Scalars['String']['input'];
  item_variant_key_list?: InputMaybe<Array<ItemVariantKeyWithoutItemInput>>;
};

export type ItemVariantValueImportInput = {
  data: Array<ItemVariantValueImportDataInput>;
  priority: Scalars['Int']['input'];
  user_unique_id: Scalars['String']['input'];
};

export type ItemVariantValueItem_Variant_Value_NameItem_Variant_Key_NameCompoundUniqueInput = {
  variant_key_name: Scalars['String']['input'];
  variant_value_name: Scalars['String']['input'];
};

export type ItemVariantValueWhereUniqueInput = {
  item_variant_value_id?: InputMaybe<Scalars['Int']['input']>;
  variant_value_name_variant_key_name?: InputMaybe<ItemVariantValueItem_Variant_Value_NameItem_Variant_Key_NameCompoundUniqueInput>;
};

export type ItemView = {
  __typename?: 'ItemView';
  available_qty?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list?: Maybe<Array<Scalars['Json']['output']>>;
  category_group?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deliver_uom_id?: Maybe<Scalars['Int']['output']>;
  deliver_uom_name_th?: Maybe<Scalars['String']['output']>;
  deliver_uom_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_attribute?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  item_sku_qty_list?: Maybe<Array<ItemSkuQty>>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_uom_name_th?: Maybe<Scalars['String']['output']>;
  purchase_uom_unique_id?: Maybe<Scalars['String']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  sales_uom_name_th?: Maybe<Scalars['String']['output']>;
  sales_uom_unique_id?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  seller_unique_id?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  special_price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  stock_uom_name_th?: Maybe<Scalars['String']['output']>;
  stock_uom_unique_id?: Maybe<Scalars['String']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  total_sku_qty?: Maybe<Scalars['Json']['output']>;
  tracability?: Maybe<Tracability>;
  transit_qty?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ItemType>;
  uom_group?: Maybe<Scalars['Json']['output']>;
};

export type ItemViewAggrid = {
  __typename?: 'ItemViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemView>;
};

export type ItemWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ItemWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ItemWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ItemWhereInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketingModelType {
  PromotionSetting = 'promotion_setting'
}

export type Mutation = {
  __typename?: 'Mutation';
  ActivityLogCreate?: Maybe<ActivityLog>;
  ClearReportRequestHistory: Scalars['Boolean']['output'];
  GoodsAdjustCreate: GoodsAdjust;
  GoodsAdjustUpdate: GoodsAdjust;
  GoodsIssueCreate: GoodsIssue;
  GoodsIssueDelete?: Maybe<GoodsIssue>;
  GoodsIssueUpdate: GoodsIssue;
  GoodsReceiveCreate: GoodsReceive;
  GoodsReceiveDelete?: Maybe<GoodsReceive>;
  GoodsReceiveUpdate: GoodsReceive;
  GoodsReturnCreate: GoodsReturn;
  GoodsReturnDelete?: Maybe<GoodsReturn>;
  GoodsReturnUpdate: GoodsReturn;
  GoodsTransferCreate: GoodsTransfer;
  GoodsTransferUpdate: GoodsTransfer;
  ImportBundleItems: InventoryImportResult;
  ImportItemImages: InventoryImportResult;
  ImportItemInBundles: InventoryImportResult;
  ImportItemPriceListAll: InventoryImportResult;
  ImportItemPriceListByItem: InventoryImportResult;
  ImportItemStockLimit: InventoryImportResult;
  ImportItemVariantPrice: InventoryImportResult;
  ImportItemVariantValue: InventoryImportResult;
  ImportNormalItems: InventoryImportResult;
  ImportServiceItems: InventoryImportResult;
  ImportVariantItems: InventoryImportResult;
  InventoryDocumentCancel?: Maybe<InventoryDocumentCancelOutput>;
  InventoryDocumentCancelWithPendingScan?: Maybe<InventoryDocumentCancelPendingScanOutput>;
  ItemAdjustmentCreate: ItemAdjustment;
  ItemAdjustmentDelete: ItemAdjustment;
  ItemAdjustmentUpdate: ItemAdjustment;
  ItemPriceListCreate: ItemPriceList;
  ItemPriceListDelete: ItemPriceList;
  ItemPriceListUpdate: ItemPriceList;
  ItemVariantValueCreate?: Maybe<ItemVariantValue>;
  TraceEntryCreate: TraceEntry;
  UnitCreate: Unit;
  UnitDelete: Unit;
  UnitUpdate: Unit;
  bundleItemDetailCreate?: Maybe<BundleItemDetail>;
  bundleItemDetailDelete?: Maybe<BundleItemDetail>;
  bundleItemDetailUpdate?: Maybe<BundleItemDetail>;
  itemCreateWithUOM?: Maybe<Item>;
  itemDelete?: Maybe<Item>;
  itemSkuDetailCreate?: Maybe<ItemSkuDetail>;
  itemSkuDetailDisable?: Maybe<ItemSkuDetail>;
  itemSkuDetailUpdate?: Maybe<ItemSkuDetail>;
  itemSkuQtyCreate?: Maybe<ItemSkuQty>;
  itemSkuQtyCreateMany?: Maybe<Array<Maybe<ItemSkuQty>>>;
  itemSkuQtyDelete?: Maybe<ItemSkuQty>;
  itemSkuQtyUpdate?: Maybe<ItemSkuQty>;
  itemSkuValueCreate: ItemSkuValue;
  itemSkuValueDisable?: Maybe<ItemSkuValue>;
  itemUpdateWithSku?: Maybe<Item>;
  itemVariantKeysCreate?: Maybe<ItemVariantKey>;
  recalculateAllItemSkuQtys?: Maybe<Scalars['Boolean']['output']>;
  uomConversionCreate?: Maybe<UomConversion>;
  uomConversionDelete?: Maybe<UomConversion>;
  uomConversionUpdate?: Maybe<UomConversion>;
  uomGroupCreate?: Maybe<UomGroup>;
  uomGroupCreateMany?: Maybe<UomGroupCreateManyOutput>;
  uomGroupDelete?: Maybe<UomGroup>;
  uomGroupUpdate?: Maybe<UomGroup>;
};


export type MutationActivityLogCreateArgs = {
  data: ActivityLogCreateInput;
};


export type MutationGoodsAdjustCreateArgs = {
  createInput: GoodsAdjustCreateInput;
};


export type MutationGoodsAdjustUpdateArgs = {
  uniqueInput: GoodsAdjustWhereUniqueInput;
  updateInput: GoodsAdjustUpdateInput;
};


export type MutationGoodsIssueCreateArgs = {
  createInput: GoodsIssueCreateInput;
};


export type MutationGoodsIssueDeleteArgs = {
  uniqueInput: GoodsIssueWhereUniqueInput;
};


export type MutationGoodsIssueUpdateArgs = {
  uniqueInput: GoodsIssueWhereUniqueInput;
  updateInput: GoodsIssueUpdateInput;
};


export type MutationGoodsReceiveCreateArgs = {
  createInput: GoodsReceiveCreateInput;
};


export type MutationGoodsReceiveDeleteArgs = {
  uniqueInput: GoodsReceiveWhereUniqueInput;
};


export type MutationGoodsReceiveUpdateArgs = {
  uniqueInput: GoodsReceiveWhereUniqueInput;
  updateInput: GoodsReceiveUpdateInput;
};


export type MutationGoodsReturnCreateArgs = {
  createInput: GoodsReturnCreateInput;
};


export type MutationGoodsReturnDeleteArgs = {
  uniqueInput: GoodsReturnWhereUniqueInput;
};


export type MutationGoodsReturnUpdateArgs = {
  uniqueInput: GoodsReturnWhereUniqueInput;
  updateInput: GoodsReturnUpdateInput;
};


export type MutationGoodsTransferCreateArgs = {
  createInput: GoodsTransferCreateInput;
};


export type MutationGoodsTransferUpdateArgs = {
  uniqueInput: GoodsTransferWhereUniqueInput;
  updateInput: GoodsTransferUpdateInput;
};


export type MutationImportBundleItemsArgs = {
  importInput: ItemBundleImportInput;
};


export type MutationImportItemImagesArgs = {
  importInput: ItemImageImportInput;
};


export type MutationImportItemInBundlesArgs = {
  importInput: ItemInBundleImportInput;
};


export type MutationImportItemPriceListAllArgs = {
  importInput: ItemPriceListAllImportInput;
};


export type MutationImportItemPriceListByItemArgs = {
  importInput: ItemPriceListByItemImportInput;
};


export type MutationImportItemStockLimitArgs = {
  importInput: ItemStockLimitImportInput;
};


export type MutationImportItemVariantPriceArgs = {
  importInput: ItemVariantPriceImportInput;
};


export type MutationImportItemVariantValueArgs = {
  importInput: ItemVariantValueImportInput;
};


export type MutationImportNormalItemsArgs = {
  importInput: ItemNormalImportInput;
};


export type MutationImportServiceItemsArgs = {
  importInput: ItemServiceImportInput;
};


export type MutationImportVariantItemsArgs = {
  importInput: ItemVariantImportInput;
};


export type MutationInventoryDocumentCancelArgs = {
  documentType?: InputMaybe<InventoryDocumentType>;
  uniqueInput: GoodsReceiveWhereUniqueInput;
};


export type MutationInventoryDocumentCancelWithPendingScanArgs = {
  documentType?: InputMaybe<InventoryDocumentType>;
  uniqueInput: GoodsReceiveWhereUniqueInput;
};


export type MutationItemAdjustmentCreateArgs = {
  data: ItemAdjustmentCreateInput;
};


export type MutationItemAdjustmentDeleteArgs = {
  uniqueInput: ItemAdjustmentUniqueInput;
};


export type MutationItemAdjustmentUpdateArgs = {
  data: ItemAdjustmentUpdateInput;
  uniqueInput: ItemAdjustmentUniqueInput;
};


export type MutationItemPriceListCreateArgs = {
  data: ItemPriceListCreateInput;
};


export type MutationItemPriceListDeleteArgs = {
  uniqueInput: ItemPriceListUniqueInput;
};


export type MutationItemPriceListUpdateArgs = {
  data: ItemPriceListUpdateInput;
  uniqueInput: ItemPriceListUniqueInput;
};


export type MutationItemVariantValueCreateArgs = {
  createInput: ItemVariantValueCreate;
};


export type MutationTraceEntryCreateArgs = {
  createInput: TraceEntryCreateInput;
};


export type MutationUnitCreateArgs = {
  data: UnitCreateInput;
};


export type MutationUnitDeleteArgs = {
  uniqueInput: UnitUniqueInput;
};


export type MutationUnitUpdateArgs = {
  data: UnitUpdateInput;
  uniqueInput: UnitUniqueInput;
};


export type MutationBundleItemDetailCreateArgs = {
  createInput: BundleItemDetailCreateInput;
};


export type MutationBundleItemDetailDeleteArgs = {
  uniqueInput: BundleItemDetailUniqueInput;
};


export type MutationBundleItemDetailUpdateArgs = {
  uniqueInput: BundleItemDetailUniqueInput;
  updateInput: BundleItemDetailUpdateInput;
};


export type MutationItemCreateWithUomArgs = {
  createInput: ItemCreateDirectInput;
};


export type MutationItemDeleteArgs = {
  uniqueInput: ItemWhereUniqueInput;
};


export type MutationItemSkuDetailCreateArgs = {
  createInput: ItemSkuDetailCreateInput;
};


export type MutationItemSkuDetailDisableArgs = {
  uniqueInput: ItemSkuDetailUniqueInput;
};


export type MutationItemSkuDetailUpdateArgs = {
  uniqueInput: ItemSkuDetailUniqueInput;
  updateInput: ItemSkuDetailUpdateInput;
};


export type MutationItemSkuQtyCreateArgs = {
  createInput: ItemSkuQtyCreateInput;
};


export type MutationItemSkuQtyCreateManyArgs = {
  createManyInput: Array<ItemSkuQtyCreateInput>;
};


export type MutationItemSkuQtyDeleteArgs = {
  uniqueInput: ItemSkuQtyWhereUniqueInput;
};


export type MutationItemSkuQtyUpdateArgs = {
  uniqueInput: ItemSkuQtyWhereUniqueInput;
  updateInput: ItemSkuQtyUpdateInput;
};


export type MutationItemSkuValueCreateArgs = {
  createInput: ItemSkuValueCreateInput;
};


export type MutationItemSkuValueDisableArgs = {
  uniqueInput: ItemSkuValueUniqueInput;
};


export type MutationItemUpdateWithSkuArgs = {
  uniqueInput: ItemWhereUniqueInput;
  updateInput: ItemUpdateWithSkuInput;
};


export type MutationItemVariantKeysCreateArgs = {
  createInput: ItemVariantKeyCreateInput;
};


export type MutationUomConversionCreateArgs = {
  createInput: UomConversionCreateInput;
};


export type MutationUomConversionDeleteArgs = {
  uniqueInput: UomConversionWhereUniqueInput;
};


export type MutationUomConversionUpdateArgs = {
  uniqueInput: UomConversionWhereUniqueInput;
  updateInput: UomConversionUpdateInput;
};


export type MutationUomGroupCreateArgs = {
  createInput: UomGroupCreateInput;
};


export type MutationUomGroupCreateManyArgs = {
  createManyInput: Array<UomGroupCreateInput>;
};


export type MutationUomGroupDeleteArgs = {
  uniqueInput: UomGroupWhereUniqueInput;
};


export type MutationUomGroupUpdateArgs = {
  uniqueInput: UomGroupWhereUniqueInput;
  updateInput: UomGroupUpdateInput;
};

export type NoTraceEntryReportView = {
  __typename?: 'NoTraceEntryReportView';
  available_qty?: Maybe<Scalars['Int']['output']>;
  category_group?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
};

export type NoTraceEntryReportViewAggrid = {
  __typename?: 'NoTraceEntryReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<NoTraceEntryReportView>>;
};

export enum PriceVatType {
  ExcludeVat = 'exclude_vat',
  IncludeVat = 'include_vat'
}

export type PromotionAppliedLog = {
  __typename?: 'PromotionAppliedLog';
  cash_sales?: Maybe<CashSales>;
  cash_sales_id?: Maybe<Scalars['Int']['output']>;
  conditional_item_id_list: Array<Scalars['Int']['output']>;
  coupon_code: Scalars['String']['output'];
  discount_rate?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  promotion_id: Scalars['Int']['output'];
  promotion_unique_id?: Maybe<Scalars['String']['output']>;
  receive_type?: Maybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['output']>;
  total_discount_amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PromotionAppliedLogUpsertInput = {
  conditional_item_id_list: Array<Scalars['Int']['input']>;
  coupon_code: Scalars['String']['input'];
  discount_rate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  promotion_id: Scalars['Int']['input'];
  promotion_unique_id?: InputMaybe<Scalars['String']['input']>;
  receive_type?: InputMaybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['input']>;
  total_discount_amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PromotionCategory {
  DiscountOrder = 'discount_order',
  DiscountProduct = 'discount_product',
  DiscountTotal = 'discount_total',
  FreeGift = 'free_gift'
}

export enum PromotionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum PromotionType {
  AllPromotions = 'all_promotions',
  SingleCategoryPromotion = 'single_category_promotion',
  SinglePromotion = 'single_promotion'
}

export enum PurchaseCondition {
  AllItems = 'all_items',
  SpecificItems = 'specific_items'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  reference_document_type: PurchaseDocumentType;
  reference_line_item?: Maybe<ReferencePurchaseLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id: Scalars['Int']['output'];
  uom_name: Scalars['String']['output'];
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseReferenceDocument = {
  __typename?: 'PurchaseReferenceDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseReferenceType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseReferenceDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseReferenceType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum PurchaseReferenceType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  SalesOrder = 'sales_order'
}

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  accepted_remark?: Maybe<Scalars['String']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  delivery_address?: Maybe<Scalars['Json']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Scalars['Json']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseReturn = {
  __typename?: 'PurchaseReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  ActivityLogFindManyAggrid: ActivityLogFindManyAggrid;
  ActivityLogFindManyByReferenceId: Array<ActivityLog>;
  ActivityLogFindUnique?: Maybe<ActivityLog>;
  CurrentExportRequest?: Maybe<Scalars['Json']['output']>;
  CurrentImportRequest?: Maybe<Scalars['Json']['output']>;
  CurrentReportRequest?: Maybe<Scalars['Json']['output']>;
  CurrentStockByBranchReportView?: Maybe<CurrentStockByBranchReportViewAggrid>;
  CurrentStockByLocationReportView?: Maybe<CurrentStockByLocationReportViewAggrid>;
  CurrentStockByLotReportView?: Maybe<CurrentStockByLotReportViewAggrid>;
  CurrentStockBySNReportView?: Maybe<CurrentStockBySnReportViewAggrid>;
  CurrentStockByWarehouseReportView?: Maybe<CurrentStockByWarehouseReportViewAggrid>;
  GenerateExport: ReportResult;
  GenerateExportedDataNoQueue?: Maybe<Scalars['String']['output']>;
  GenerateReport: ReportResult;
  GenerateReportNoQueue?: Maybe<Scalars['String']['output']>;
  GoodsAdjust: GoodsAdjust;
  GoodsAdjustReportView?: Maybe<GoodsAdjustReportViewAggrid>;
  GoodsAdjustView?: Maybe<GoodsAdjustViewAggrid>;
  GoodsIssue?: Maybe<GoodsIssue>;
  GoodsIssueReportView?: Maybe<GoodsIssueReportViewAggrid>;
  GoodsIssues?: Maybe<Array<GoodsIssue>>;
  GoodsIssuesFindManyAggrid?: Maybe<GoodsIssueAggrid>;
  GoodsIssuesView?: Maybe<GoodsIssueViewAggrid>;
  GoodsReceive?: Maybe<GoodsReceive>;
  GoodsReceiveReportView?: Maybe<GoodsReceiveReportViewAggrid>;
  GoodsReceives?: Maybe<Array<GoodsReceive>>;
  GoodsReceivesFindManyAggrid?: Maybe<GoodsReceiveAggrid>;
  GoodsReceivesView?: Maybe<GoodsReceiveViewAggrid>;
  GoodsReturn?: Maybe<GoodsReturn>;
  GoodsReturnReportView?: Maybe<GoodsReturnReportViewAggrid>;
  GoodsReturns?: Maybe<Array<GoodsReturn>>;
  GoodsReturnsFindManyAggrid?: Maybe<GoodsReturnAggrid>;
  GoodsReturnsView?: Maybe<GoodsReturnViewAggrid>;
  GoodsTransfer?: Maybe<GoodsTransfer>;
  GoodsTransferFindManyAggrid?: Maybe<GoodsTransferAggrid>;
  GoodsTransferReportView?: Maybe<GoodsTransferReportViewAggrid>;
  GoodsTransferView?: Maybe<GoodsTransferViewAggrid>;
  HistoryExportRequest?: Maybe<Scalars['Json']['output']>;
  HistoryImportRequest?: Maybe<Scalars['Json']['output']>;
  HistoryReportRequest?: Maybe<Scalars['Json']['output']>;
  ItemAdjustmentFindUnique?: Maybe<ItemPriceList>;
  ItemAdjustmentGetAllByItemPriceList: Array<Maybe<ItemAdjustment>>;
  ItemPriceListFindAll?: Maybe<Array<Maybe<ItemPriceList>>>;
  ItemPriceListFindUnique?: Maybe<ItemPriceList>;
  ItemPriceListViewAggrid: ItemPriceListViewAggridOutput;
  ItemPriceListViewFindUnique?: Maybe<ItemPriceListView>;
  ItemSkuQtyBySkuView?: Maybe<ItemSkuQtyBySkuView>;
  ItemSkuQtysByBarcodeView?: Maybe<ItemSkuQtyByBarcodeViewAggrid>;
  ItemSkuQtysByBinLocationView?: Maybe<ItemSkuQtyByBinLocationViewAggrid>;
  ItemSkuQtysByBranchView?: Maybe<ItemSkuQtyByBranchViewAggrid>;
  ItemSkuQtysByWarehouseView?: Maybe<ItemSkuQtyByWarehouseViewAggrid>;
  ItemsView: ItemViewAggrid;
  NoTraceEntryReportView?: Maybe<NoTraceEntryReportViewAggrid>;
  RecentHistoryReportRequest?: Maybe<Scalars['Json']['output']>;
  TraceEntries?: Maybe<Array<Maybe<TraceEntry>>>;
  TraceEntriesFindManyAggrid?: Maybe<TraceEntryAggridOutput>;
  TraceEntriesView?: Maybe<TraceEntryViewAggridOutput>;
  TraceEntry?: Maybe<TraceEntry>;
  TraceEntryReportView?: Maybe<TraceEntryReportViewAggrid>;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
  UnitFindUnique?: Maybe<Unit>;
  UnitsFindAll: Array<Unit>;
  UnscannedSNReportView?: Maybe<UnscannedSnReportViewAggrid>;
  ValidateItemImport: ValidateItemImportResult;
  ValidateItemIsInUse?: Maybe<ItemValidationResult>;
  ValidatePriceListIsInUse?: Maybe<ValidatePriceListIsInUseResult>;
  bundleItemDetail?: Maybe<BundleItemDetail>;
  bundleItemDetails?: Maybe<Array<Maybe<BundleItemDetail>>>;
  dummy?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Item>;
  itemSkuDetail?: Maybe<ItemSkuDetail>;
  itemSkuDetailByItem?: Maybe<Array<Maybe<ItemSkuDetail>>>;
  itemSkuDetails?: Maybe<Array<Maybe<ItemSkuDetail>>>;
  itemSkuDetailsFindManyAggrid?: Maybe<ItemSkuDetailAggrid>;
  itemSkuQty?: Maybe<ItemSkuQty>;
  itemSkuQtys?: Maybe<Array<Maybe<ItemSkuQty>>>;
  itemSkuValue?: Maybe<ItemSkuValue>;
  itemSkuValueByItem: Array<Maybe<ItemSkuValue>>;
  itemSkuValues: Array<Maybe<ItemSkuValue>>;
  itemVariantIsDeletable?: Maybe<Scalars['Boolean']['output']>;
  itemVariantKeysByItem?: Maybe<ItemVariantKey>;
  itemVariantValuesByItem?: Maybe<Array<Maybe<ItemVariantValue>>>;
  items?: Maybe<Array<Item>>;
  uomConversion?: Maybe<UomConversion>;
  uomConversions?: Maybe<Array<Maybe<UomConversion>>>;
  uomGroup?: Maybe<UomGroup>;
  uomGroups?: Maybe<Array<Maybe<UomGroup>>>;
};


export type QueryActivityLogFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryActivityLogFindManyByReferenceIdArgs = {
  findManyInput: ActivityLogByRefereceIdInput;
};


export type QueryActivityLogFindUniqueArgs = {
  uniqueInput?: InputMaybe<ActivityLogUniqueInput>;
};


export type QueryCurrentImportRequestArgs = {
  userUniqueId: Scalars['String']['input'];
};


export type QueryCurrentStockByBranchReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCurrentStockByLocationReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCurrentStockByLotReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCurrentStockBySnReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCurrentStockByWarehouseReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGenerateExportArgs = {
  input?: InputMaybe<ExportGenerateInput>;
};


export type QueryGenerateExportedDataNoQueueArgs = {
  input?: InputMaybe<ExportGenerateInput>;
};


export type QueryGenerateReportArgs = {
  input: ReportGenerateInput;
};


export type QueryGenerateReportNoQueueArgs = {
  input: ReportGenerateInput;
};


export type QueryGoodsAdjustArgs = {
  uniqueInput?: InputMaybe<GoodsAdjustWhereUniqueInput>;
};


export type QueryGoodsAdjustReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsAdjustViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsIssueArgs = {
  uniqueInput?: InputMaybe<GoodsIssueWhereUniqueInput>;
};


export type QueryGoodsIssueReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsIssuesFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsIssuesViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReceiveArgs = {
  uniqueInput?: InputMaybe<GoodsReceiveWhereUniqueInput>;
};


export type QueryGoodsReceiveReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReceivesFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReceivesViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReturnArgs = {
  uniqueInput?: InputMaybe<GoodsReturnWhereUniqueInput>;
};


export type QueryGoodsReturnReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReturnsFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsReturnsViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsTransferArgs = {
  uniqueInput?: InputMaybe<GoodsTransferWhereUniqueInput>;
};


export type QueryGoodsTransferFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsTransferReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodsTransferViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHistoryImportRequestArgs = {
  userUniqueId: Scalars['String']['input'];
};


export type QueryItemAdjustmentFindUniqueArgs = {
  uniqueInput: ItemPriceListUniqueInput;
};


export type QueryItemAdjustmentGetAllByItemPriceListArgs = {
  itemPriceListUniqueInput: ItemPriceListUniqueInput;
};


export type QueryItemPriceListFindAllArgs = {
  filterInput?: InputMaybe<ItemPriceListFindAllInput>;
};


export type QueryItemPriceListFindUniqueArgs = {
  uniqueInput: ItemPriceListUniqueInput;
};


export type QueryItemPriceListViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemPriceListViewFindUniqueArgs = {
  uniqueInput: ItemPriceListUniqueInput;
};


export type QueryItemSkuQtyBySkuViewArgs = {
  skuName: Scalars['String']['input'];
};


export type QueryItemSkuQtysByBarcodeViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemSkuQtysByBinLocationViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemSkuQtysByBranchViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemSkuQtysByWarehouseViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemsViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryNoTraceEntryReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryTraceEntriesFindManyAggridArgs = {
  aggridInput?: InputMaybe<AggridTemplateInput>;
};


export type QueryTraceEntriesViewArgs = {
  aggridInput?: InputMaybe<AggridTemplateInput>;
};


export type QueryTraceEntryArgs = {
  uniqueInput: TraceEntryWhereUniqueInput;
};


export type QueryTraceEntryReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: WmsModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: WmsModelType;
  uniqueId: Scalars['String']['input'];
};


export type QueryUnitFindUniqueArgs = {
  uniqueInput: UnitUniqueInput;
};


export type QueryUnitsFindAllArgs = {
  findManyInput?: InputMaybe<UnitWhereInput>;
};


export type QueryUnscannedSnReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryValidateItemImportArgs = {
  validateInput: ItemInputValidateInput;
};


export type QueryValidateItemIsInUseArgs = {
  validateInput?: InputMaybe<ItemValidationInput>;
};


export type QueryValidatePriceListIsInUseArgs = {
  validatePriceListInput?: InputMaybe<ValidatePriceListInput>;
};


export type QueryBundleItemDetailArgs = {
  uniqueInput: BundleItemDetailUniqueInput;
};


export type QueryItemArgs = {
  uniqueInput: ItemWhereUniqueInput;
};


export type QueryItemSkuDetailArgs = {
  uniqueInput?: InputMaybe<ItemSkuDetailUniqueInput>;
};


export type QueryItemSkuDetailByItemArgs = {
  itemUniqueId: Scalars['String']['input'];
};


export type QueryItemSkuDetailsArgs = {
  findManyInput?: InputMaybe<ItemSkuDetailWhereInput>;
};


export type QueryItemSkuDetailsFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryItemSkuQtyArgs = {
  uniqueInput: ItemSkuQtyWhereUniqueInput;
};


export type QueryItemSkuQtysArgs = {
  findManyInput?: InputMaybe<ItemSkuQtyFindManyInput>;
};


export type QueryItemSkuValueArgs = {
  uniqueInput: ItemSkuValueUniqueInput;
};


export type QueryItemSkuValueByItemArgs = {
  itemUniqueId: Scalars['String']['input'];
};


export type QueryItemVariantIsDeletableArgs = {
  whereUniqueInput: ItemVariantValidateWhereInput;
};


export type QueryItemVariantKeysByItemArgs = {
  findByItemInput: ItemVariantKeyByItemInput;
};


export type QueryItemVariantValuesByItemArgs = {
  findByItemInput: ItemVariantValueByItemInput;
};


export type QueryItemsArgs = {
  findManyInput?: InputMaybe<ItemWhereInput>;
};


export type QueryUomConversionArgs = {
  uniqueInput: UomConversionWhereUniqueInput;
};


export type QueryUomConversionsArgs = {
  findManyInput?: InputMaybe<UomConversionFindManyInput>;
};


export type QueryUomGroupArgs = {
  uniqueInput: UomGroupWhereUniqueInput;
};


export type QueryUomGroupsArgs = {
  findManyInput?: InputMaybe<UomGroupFindManyInput>;
};

export type Quotation = {
  __typename?: 'Quotation';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  attachment_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  contact_unique_id?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<Maybe<SalesItem>>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Maybe<Tag>>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum ReceiveType {
  Amount = 'amount',
  Percent = 'percent'
}

export type ReferencePurchaseLineItem = {
  __typename?: 'ReferencePurchaseLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_document_unique_id: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferencePurchaseLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_document_unique_id: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type ReferenceSalesDocument = {
  __typename?: 'ReferenceSalesDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<SalesReferenceDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceSalesDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<SalesReferenceDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSalesLineItem = {
  __typename?: 'ReferenceSalesLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferenceSalesLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type ReportGenerateInput = {
  params?: InputMaybe<Scalars['Json']['input']>;
  priority: Scalars['Int']['input'];
  report_type: InventoryReportType;
  user_unique_id: Scalars['String']['input'];
};

export type ReportResult = {
  __typename?: 'ReportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  jobId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type RolePermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item_price_list?: Maybe<Array<Maybe<ItemPriceList>>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en: Scalars['String']['output'];
  name_th: Scalars['String']['output'];
  quotation_list?: Maybe<Array<Maybe<Quotation>>>;
  unique_id: Scalars['String']['output'];
};

export enum SalesChannelType {
  All = 'all',
  SpecificChannels = 'specific_channels',
  SpecificSales = 'specific_sales'
}

export type SalesDeduction = {
  __typename?: 'SalesDeduction';
  branch_id: Scalars['Int']['output'];
  credit_balance?: Maybe<Scalars['Float']['output']>;
  deduction_amount?: Maybe<Scalars['Float']['output']>;
  deduction_issue_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
};

export type SalesInvoice = {
  __typename?: 'SalesInvoice';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  customer_details: Scalars['Json']['output'];
  customer_unique_id: Scalars['String']['output'];
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type: PriceVatType;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesItem = {
  __typename?: 'SalesItem';
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id: Scalars['Int']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  promotion_discount?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_invoiced?: Maybe<Scalars['Float']['output']>;
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  qty_shipped?: Maybe<Scalars['Float']['output']>;
  qty_to_ship?: Maybe<Scalars['Float']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_line_item?: Maybe<ReferenceSalesLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  so_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  volume: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export enum SalesModelType {
  CashSales = 'cash_sales',
  CashSalesTax = 'cash_sales_tax',
  CustomerDeposit = 'customer_deposit',
  CustomerDepositTax = 'customer_deposit_tax',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesInvoiceTax = 'sales_invoice_tax',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return'
}

export type SalesOrder = {
  __typename?: 'SalesOrder';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_status?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  good_issue_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  payments_receipt_status?: Maybe<Scalars['String']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_invoice_status?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesPayment = {
  __typename?: 'SalesPayment';
  branch_id: Scalars['Int']['output'];
  cheque_date?: Maybe<Scalars['DateTime']['output']>;
  cheque_no?: Maybe<Scalars['String']['output']>;
  cheque_provider?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_withholding_tax?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  payment_channel_id?: Maybe<Scalars['Int']['output']>;
  payment_channel_name?: Maybe<Scalars['String']['output']>;
  payment_channel_payment_name?: Maybe<Scalars['String']['output']>;
  payment_channel_unique_id?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_rate?: Maybe<Scalars['String']['output']>;
};

export enum SalesReferenceDocumentType {
  CashSales = 'cash_sales',
  CustomerDeposit = 'customer_deposit',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  TaxInvoice = 'tax_invoice'
}

export type SalesReturn = {
  __typename?: 'SalesReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_effect_stock?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Subscription = {
  __typename?: 'Subscription';
  SubscriptionImportReport?: Maybe<SubscriptionStatus>;
};

export type SubscriptionExportResult = {
  __typename?: 'SubscriptionExportResult';
  export?: Maybe<Scalars['Json']['output']>;
  export_type?: Maybe<InventoryExportType>;
};

export type SubscriptionImportResult = {
  __typename?: 'SubscriptionImportResult';
  import?: Maybe<Scalars['Json']['output']>;
  import_type?: Maybe<InventoryImportType>;
};

export type SubscriptionReportResult = {
  __typename?: 'SubscriptionReportResult';
  report?: Maybe<Scalars['Json']['output']>;
  report_type?: Maybe<InventoryReportType>;
};

export type SubscriptionStatus = {
  __typename?: 'SubscriptionStatus';
  export_result?: Maybe<SubscriptionExportResult>;
  import_result?: Maybe<SubscriptionImportResult>;
  report_result?: Maybe<SubscriptionReportResult>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<InventorySubscriptionType>;
};

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task',
  Vendor = 'vendor'
}

export enum Tracability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export enum TraceAbilityEnum {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type TraceEntry = {
  __typename?: 'TraceEntry';
  additional_cost?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  cost_price?: Maybe<Scalars['Float']['output']>;
  created_date: Scalars['DateTime']['output'];
  delivery_order_unique_id?: Maybe<Scalars['String']['output']>;
  destination_bin_location?: Maybe<BinLocation>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_scanned_by?: Maybe<Scalars['Json']['output']>;
  destination_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  document_item_qty?: Maybe<Scalars['Int']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  goods_adjust_unique_id?: Maybe<Scalars['String']['output']>;
  goods_issue_unique_id?: Maybe<Scalars['String']['output']>;
  goods_receive_unique_id?: Maybe<Scalars['String']['output']>;
  goods_return_unique_id?: Maybe<Scalars['String']['output']>;
  goods_transfer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_stockable: Scalars['Boolean']['output'];
  item_img_url: Array<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  po_reference_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  posted_qty?: Maybe<Scalars['Int']['output']>;
  qty: Scalars['Int']['output'];
  reference_line_item?: Maybe<InventoryReferenceLineItem>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by?: Maybe<Scalars['Json']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  source_bin_location?: Maybe<BinLocation>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  tracability: Tracability;
  type: InventoryDocumentType;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Unit>;
  uom_id?: Maybe<Scalars['Int']['output']>;
};

export type TraceEntryAggridOutput = {
  __typename?: 'TraceEntryAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TraceEntry>>>;
};

export type TraceEntryCreateInput = {
  additional_cost?: InputMaybe<Scalars['Float']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  delivery_order_unique_id?: InputMaybe<Scalars['String']['input']>;
  destination_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_scanned_by?: InputMaybe<Scalars['Json']['input']>;
  destination_scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  document_item_qty?: InputMaybe<Scalars['Int']['input']>;
  expired_date?: InputMaybe<Scalars['DateTime']['input']>;
  goods_adjust_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_issue_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_receive_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_return_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_transfer_unique_id?: InputMaybe<Scalars['String']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  manufactured_date?: InputMaybe<Scalars['DateTime']['input']>;
  po_reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  posted_qty?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  reference_line_item?: InputMaybe<InventoryReferenceLineItemInput>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  scanned_by?: InputMaybe<Scalars['Json']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
  source_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  tracability: Tracability;
  type?: InputMaybe<InventoryDocumentType>;
  unique_id: Scalars['String']['input'];
  uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TraceEntryReportView = {
  __typename?: 'TraceEntryReportView';
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_bin_location_name?: Maybe<Scalars['String']['output']>;
  destination_branch_id?: Maybe<Scalars['Int']['output']>;
  destination_branch_name?: Maybe<Scalars['String']['output']>;
  destination_branch_unique_id?: Maybe<Scalars['String']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  source_branch_id?: Maybe<Scalars['Int']['output']>;
  source_branch_name?: Maybe<Scalars['String']['output']>;
  source_branch_unique_id?: Maybe<Scalars['String']['output']>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type TraceEntryReportViewAggrid = {
  __typename?: 'TraceEntryReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<TraceEntryReportView>>;
};

export type TraceEntryView = {
  __typename?: 'TraceEntryView';
  barcode?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_bin_location_name?: Maybe<Scalars['String']['output']>;
  destination_branch_id?: Maybe<Scalars['String']['output']>;
  destination_warehouse_id?: Maybe<Scalars['String']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destinaton_branch_name?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  scanned_by?: Maybe<Scalars['String']['output']>;
  scanned_by_object?: Maybe<Scalars['Json']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  source_branch_id?: Maybe<Scalars['String']['output']>;
  source_branch_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_id?: Maybe<Scalars['String']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InventoryDocumentType>;
  unique_id: Scalars['String']['output'];
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name_en?: Maybe<Scalars['String']['output']>;
  uom_name_th?: Maybe<Scalars['String']['output']>;
  uom_unique_id?: Maybe<Scalars['String']['output']>;
};

export type TraceEntryViewAggridOutput = {
  __typename?: 'TraceEntryViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TraceEntryView>>>;
};

export type TraceEntryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Unit = {
  __typename?: 'Unit';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_th: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type UnitCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_th: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
};

export type UnitFindManyInput = {
  cursor?: InputMaybe<UnitUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UnitScalarField>>>;
  orderBy?: InputMaybe<Array<InputMaybe<UnitOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UnitUniqueInput>;
};

export type UnitListRelationFilter = {
  every?: InputMaybe<UnitWhereInput>;
  none?: InputMaybe<UnitWhereInput>;
  some?: InputMaybe<UnitWhereInput>;
};

export type UnitOrderByWithRelationInput = {
  id?: InputMaybe<Scalars['Any']['input']>;
  name_en?: InputMaybe<Scalars['Any']['input']>;
  name_th?: InputMaybe<Scalars['Any']['input']>;
  unique_id?: InputMaybe<Scalars['Any']['input']>;
};

export enum UnitScalarField {
  NameTh = 'name_th',
  UniqueId = 'unique_id'
}

export type UnitUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type UnitUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_th?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type UnitWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UnitWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UnitWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UnitWhereInput>>>;
  id?: InputMaybe<Scalars['Any']['input']>;
  name_en?: InputMaybe<Scalars['Any']['input']>;
  name_th?: InputMaybe<Scalars['Any']['input']>;
  unique_id?: InputMaybe<Scalars['Any']['input']>;
};

export type UnscannedSnReportView = {
  __typename?: 'UnscannedSNReportView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  last_updated_by_name?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type UnscannedSnReportViewAggrid = {
  __typename?: 'UnscannedSNReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<UnscannedSnReportView>>;
};

export type UomConversion = {
  __typename?: 'UomConversion';
  base_uom_rate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  target_uom: Unit;
  target_uom_id: Scalars['Int']['output'];
  target_uom_rate: Scalars['Float']['output'];
  uom_group: UomGroup;
  uom_group_id: Scalars['Int']['output'];
};

export type UomConversionArgs = {
  include?: InputMaybe<UomConversionIncludeInput>;
};

export type UomConversionCreateInput = {
  base_uom_rate: Scalars['Float']['input'];
  target_uom_id: Scalars['String']['input'];
  target_uom_rate: Scalars['Float']['input'];
  uom_group_id: Scalars['String']['input'];
};

export type UomConversionCreateWithoutUomGroupInput = {
  base_uom_rate: Scalars['Float']['input'];
  target_uom_id: Scalars['Int']['input'];
  target_uom_rate: Scalars['Float']['input'];
};

export type UomConversionFindManyInput = {
  cursor?: InputMaybe<UomConversionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UomConversionScalarField>>>;
  include?: InputMaybe<UomConversionIncludeInput>;
  orderBy?: InputMaybe<Scalars['Any']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UomConversionWhereInput>;
};

export type UomConversionIncludeInput = {
  target_uom?: InputMaybe<Scalars['Boolean']['input']>;
  uom_group?: InputMaybe<UomGroupArgsInput>;
};

export type UomConversionListRelationFilter = {
  every?: InputMaybe<UomConversionWhereInput>;
  none?: InputMaybe<UomConversionWhereInput>;
  some?: InputMaybe<UomConversionWhereInput>;
};

export type UomConversionUpdateInput = {
  base_uom_rate?: InputMaybe<Scalars['Float']['input']>;
  target_uom_id?: InputMaybe<Scalars['String']['input']>;
  target_uom_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UomConversionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UomConversionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UomConversionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UomConversionWhereInput>>>;
  base_uom_rate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Any']['input']>;
  target_uom?: InputMaybe<UnitWhereInput>;
  target_uom_rate?: InputMaybe<Scalars['Any']['input']>;
  uom_group?: InputMaybe<UomGroupWhereInput>;
  uom_group_id?: InputMaybe<Scalars['Any']['input']>;
};

export type UomConversionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UomCreateError = {
  __typename?: 'UomCreateError';
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  index: Scalars['Int']['output'];
  unique_id: Scalars['String']['output'];
};

export type UomGroup = {
  __typename?: 'UomGroup';
  base_uom: Unit;
  base_uom_id: Scalars['Int']['output'];
  convertable_uom_list: Array<Unit>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  uom_conversion_list: Array<UomConversion>;
};

export type UomGroupArgsInput = {
  include?: InputMaybe<UomGroupIncludeInput>;
};

export type UomGroupCreateBaseUomInput = {
  convertable_uom_list?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionCreateWithoutUomGroupInput>>>;
};

export type UomGroupCreateInput = {
  base_uom_id: Scalars['Int']['input'];
  convertable_uom_list?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionCreateWithoutUomGroupInput>>>;
};

export type UomGroupCreateManyOutput = {
  __typename?: 'UomGroupCreateManyOutput';
  errors?: Maybe<Array<Maybe<UomCreateError>>>;
  results?: Maybe<Array<Maybe<UomGroup>>>;
};

export type UomGroupFindManyInput = {
  cursor?: InputMaybe<UomGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UomGroupScalarField>>>;
  include?: InputMaybe<UomGroupIncludeInput>;
  orderBy?: InputMaybe<Scalars['Any']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UomGroupWhereInput>;
};

export type UomGroupIncludeInput = {
  base_uom?: InputMaybe<Scalars['Boolean']['input']>;
  convertable_uom_list?: InputMaybe<UnitFindManyInput>;
  uom_conversion_list?: InputMaybe<UomConversionFindManyInput>;
};

export type UomGroupUpdateInput = {
  base_uom_id?: InputMaybe<Scalars['Int']['input']>;
  convertable_uom_list?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionCreateWithoutUomGroupInput>>>;
};

export type UomGroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UomGroupWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UomGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UomGroupWhereInput>>>;
  base_uom?: InputMaybe<Scalars['Any']['input']>;
  base_uom_id?: InputMaybe<Scalars['Any']['input']>;
  convertable_uom_list?: InputMaybe<UnitListRelationFilter>;
  description?: InputMaybe<Scalars['Any']['input']>;
  id?: InputMaybe<Scalars['Any']['input']>;
  name?: InputMaybe<Scalars['Any']['input']>;
  unique_id?: InputMaybe<Scalars['Any']['input']>;
  uom_conversion_list?: InputMaybe<UomConversionListRelationFilter>;
};

export type UomGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum UsageLimitType {
  Limited = 'limited',
  NoLimit = 'no_limit'
}

export type User = {
  __typename?: 'User';
  company_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employee_type?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  is_sales_employee?: Maybe<Scalars['Boolean']['output']>;
  last_login_branch?: Maybe<Scalars['Int']['output']>;
  last_name: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  original_branch: Scalars['Int']['output'];
  original_branch_object?: Maybe<Branch>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  role_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  title_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  user_permission?: Maybe<UserPermission>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  id: Scalars['Int']['output'];
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  is_custom: Scalars['Boolean']['output'];
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  user_id: Scalars['Int']['output'];
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type UserPermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  is_custom: Scalars['Boolean']['input'];
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type ValidateItemImportResult = {
  __typename?: 'ValidateItemImportResult';
  existing_barcode_list?: Maybe<Array<Scalars['String']['output']>>;
  existing_item_price_list_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  existing_item_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  existing_sku_name_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_branch_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_brand_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_category_group_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_item_price_list_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_item_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_main_category_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_model_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_sales_channel_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_segment_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_series_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_sku_name_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_sub_category_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_uom_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_vendor_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_warehouse_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
};

export type ValidatePriceListInput = {
  unique_id: Scalars['String']['input'];
};

export type ValidatePriceListIsInUseResult = {
  __typename?: 'ValidatePriceListIsInUseResult';
  purchase?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sale?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  address?: Maybe<Scalars['Json']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_consignment?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_branch?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
  warehouse_level_1_list: Array<WarehouseLevel1>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export enum WmsModelType {
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  ItemBundle = 'item_bundle',
  ItemNormal = 'item_normal',
  ItemPriceList = 'item_price_list',
  ItemVariant = 'item_variant',
  Service = 'service'
}

export type WorkflowTemplate = {
  __typename?: 'WorkflowTemplate';
  approval_template_list?: Maybe<Array<ApprovalTemplate>>;
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  sub_status?: Maybe<Scalars['String']['output']>;
};

export enum UomConversionScalarField {
  BaseUomRate = 'base_uom_rate',
  Id = 'id',
  TargetUomRate = 'target_uom_rate'
}

export enum UomGroupScalarField {
  Id = 'id',
  Name = 'name'
}

export type GenerateInventoryExportQueryVariables = Exact<{
  input?: InputMaybe<ExportGenerateInput>;
}>;


export type GenerateInventoryExportQuery = { __typename?: 'Query', GenerateExportedDataNoQueue?: string | null };

export type GenerateInventoryReportNoQueueQueryVariables = Exact<{
  input: ReportGenerateInput;
}>;


export type GenerateInventoryReportNoQueueQuery = { __typename?: 'Query', GenerateReportNoQueue?: string | null };

export type GoodsAdjustCreateMutationVariables = Exact<{
  createInput: GoodsAdjustCreateInput;
}>;


export type GoodsAdjustCreateMutation = { __typename?: 'Mutation', GoodsAdjustCreate: { __typename?: 'GoodsAdjust', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id: number, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, approval_step?: number | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, destination_scanned_by?: any | null, destination_scanned_date?: any | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } } };

export type GoodsAdjustQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsAdjustWhereUniqueInput>;
}>;


export type GoodsAdjustQuery = { __typename?: 'Query', GoodsAdjust: { __typename?: 'GoodsAdjust', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id: number, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, destination_scanned_by?: any | null, destination_scanned_date?: any | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } } };

export type GoodsAdjustUpdateMutationVariables = Exact<{
  updateInput: GoodsAdjustUpdateInput;
  uniqueInput: GoodsAdjustWhereUniqueInput;
}>;


export type GoodsAdjustUpdateMutation = { __typename?: 'Mutation', GoodsAdjustUpdate: { __typename?: 'GoodsAdjust', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id: number, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, destination_scanned_by?: any | null, destination_scanned_date?: any | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } } };

export type GoodsIssueCreateMutationVariables = Exact<{
  createInput: GoodsIssueCreateInput;
}>;


export type GoodsIssueCreateMutation = { __typename?: 'Mutation', GoodsIssueCreate: { __typename?: 'GoodsIssue', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, manufactured_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };

export type GoodsIssueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsIssueWhereUniqueInput>;
}>;


export type GoodsIssueQuery = { __typename?: 'Query', GoodsIssue?: { __typename?: 'GoodsIssue', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', id: number, name: string } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } | null };

export type GoodsIssueUpdateMutationVariables = Exact<{
  updateInput: GoodsIssueUpdateInput;
  uniqueInput: GoodsIssueWhereUniqueInput;
}>;


export type GoodsIssueUpdateMutation = { __typename?: 'Mutation', GoodsIssueUpdate: { __typename?: 'GoodsIssue', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };

export type GoodsReceiveCreateMutationVariables = Exact<{
  createInput: GoodsReceiveCreateInput;
}>;


export type GoodsReceiveCreateMutation = { __typename?: 'Mutation', GoodsReceiveCreate: { __typename?: 'GoodsReceive', id: number, unique_id: string, reference_unique_id_list: Array<string>, created_date: any, posted_date?: any | null, warehouse_id?: number | null, branch_id: number, type?: string | null, aggrid_status?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, reference_unique_id?: string | null, po_reference_unique_id?: string | null, expired_date?: any | null, is_stockable: boolean, manufactured_date?: any | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> } };

export type GoodsReceiveQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsReceiveWhereUniqueInput>;
}>;


export type GoodsReceiveQuery = { __typename?: 'Query', GoodsReceive?: { __typename?: 'GoodsReceive', id: number, unique_id: string, reference_unique_id_list: Array<string>, created_date: any, posted_date?: any | null, warehouse_id?: number | null, branch_id: number, type?: string | null, aggrid_status?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string }, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, reference_unique_id?: string | null, po_reference_unique_id?: string | null, expired_date?: any | null, is_stockable: boolean, manufactured_date?: any | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> } | null };

export type GoodsReceiveUpdateMutationVariables = Exact<{
  updateInput: GoodsReceiveUpdateInput;
  uniqueInput: GoodsReceiveWhereUniqueInput;
}>;


export type GoodsReceiveUpdateMutation = { __typename?: 'Mutation', GoodsReceiveUpdate: { __typename?: 'GoodsReceive', id: number, unique_id: string, reference_unique_id_list: Array<string>, created_date: any, posted_date?: any | null, warehouse_id?: number | null, branch_id: number, type?: string | null, aggrid_status?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, reference_unique_id?: string | null, po_reference_unique_id?: string | null, manufactured_date?: any | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> } };

export type GoodsTransferCreateMutationVariables = Exact<{
  createInput: GoodsTransferCreateInput;
}>;


export type GoodsTransferCreateMutation = { __typename?: 'Mutation', GoodsTransferCreate: { __typename?: 'GoodsTransfer', id: number, unique_id: string, created_date: any, posted_date?: any | null, source_branch_id: number, source_warehouse_id?: string | null, destination_branch_id: number, destination_warehouse_id?: string | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, consignment_bin_location_id?: number | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, manufactured_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null }>, source_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, destination_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };

export type GoodsTransferQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsTransferWhereUniqueInput>;
}>;


export type GoodsTransferQuery = { __typename?: 'Query', GoodsTransfer?: { __typename?: 'GoodsTransfer', id: number, unique_id: string, created_date: any, posted_date?: any | null, source_branch_id: number, source_warehouse_id?: string | null, destination_branch_id: number, destination_warehouse_id?: string | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, consignment_bin_location_id?: number | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, destination_scanned_by?: any | null, destination_scanned_date?: any | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }>, source_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, destination_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } | null };

export type GoodsTransferUpdateMutationVariables = Exact<{
  updateInput: GoodsTransferUpdateInput;
  uniqueInput: GoodsTransferWhereUniqueInput;
}>;


export type GoodsTransferUpdateMutation = { __typename?: 'Mutation', GoodsTransferUpdate: { __typename?: 'GoodsTransfer', id: number, unique_id: string, created_date: any, posted_date?: any | null, source_branch_id: number, source_warehouse_id?: string | null, destination_branch_id: number, destination_warehouse_id?: string | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, approval_step?: number | null, reviewer_list?: Array<any> | null, approver_list?: Array<any | null> | null, remark?: string | null, consignment_bin_location_id?: number | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, stock_qty?: number | null, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, is_stockable: boolean, manufactured_date?: any | null, expired_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null }>, source_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, destination_branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, destination_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };

export type ImportBundleItemsMutationVariables = Exact<{
  importInput: ItemBundleImportInput;
}>;


export type ImportBundleItemsMutation = { __typename?: 'Mutation', ImportBundleItems: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemImagesMutationVariables = Exact<{
  importInput: ItemImageImportInput;
}>;


export type ImportItemImagesMutation = { __typename?: 'Mutation', ImportItemImages: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemInBundlesMutationVariables = Exact<{
  importInput: ItemInBundleImportInput;
}>;


export type ImportItemInBundlesMutation = { __typename?: 'Mutation', ImportItemInBundles: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemStockLimitMutationVariables = Exact<{
  importInput: ItemStockLimitImportInput;
}>;


export type ImportItemStockLimitMutation = { __typename?: 'Mutation', ImportItemStockLimit: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemVariantPriceMutationVariables = Exact<{
  importInput: ItemVariantPriceImportInput;
}>;


export type ImportItemVariantPriceMutation = { __typename?: 'Mutation', ImportItemVariantPrice: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemVariantValueMutationVariables = Exact<{
  importInput: ItemVariantValueImportInput;
}>;


export type ImportItemVariantValueMutation = { __typename?: 'Mutation', ImportItemVariantValue: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportNormalItemsMutationVariables = Exact<{
  importInput: ItemNormalImportInput;
}>;


export type ImportNormalItemsMutation = { __typename?: 'Mutation', ImportNormalItems: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportServiceItemsMutationVariables = Exact<{
  importInput: ItemServiceImportInput;
}>;


export type ImportServiceItemsMutation = { __typename?: 'Mutation', ImportServiceItems: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportVariantItemsMutationVariables = Exact<{
  importInput: ItemVariantImportInput;
}>;


export type ImportVariantItemsMutation = { __typename?: 'Mutation', ImportVariantItems: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ValidateItemImportQueryVariables = Exact<{
  validateInput: ItemInputValidateInput;
}>;


export type ValidateItemImportQuery = { __typename?: 'Query', ValidateItemImport: { __typename?: 'ValidateItemImportResult', existing_item_unique_id_list?: Array<string> | null, missing_item_unique_id_list?: Array<string> | null, existing_sku_name_list?: Array<string> | null, missing_sku_name_list?: Array<string> | null, existing_barcode_list?: Array<string> | null, missing_uom_unique_id_list?: Array<string> | null, missing_branch_unique_id_list?: Array<string> | null, missing_warehouse_unique_id_list?: Array<string> | null, missing_item_price_list_unique_id_list?: Array<string> | null, existing_item_price_list_unique_id_list?: Array<string> | null, missing_sales_channel_list?: Array<string> | null, missing_vendor_unique_id_list?: Array<string> | null, missing_category_group_list?: Array<string> | null, missing_main_category_list?: Array<string> | null, missing_sub_category_list?: Array<string> | null, missing_brand_list?: Array<string> | null, missing_segment_list?: Array<string> | null, missing_series_list?: Array<string> | null, missing_model_list?: Array<string> | null } };

export type InventoryDocumentCancelMutationVariables = Exact<{
  uniqueInput: GoodsReceiveWhereUniqueInput;
  documentType?: InputMaybe<InventoryDocumentType>;
}>;


export type InventoryDocumentCancelMutation = { __typename?: 'Mutation', InventoryDocumentCancel?: { __typename?: 'InventoryDocumentCancelOutput', unique_id: string } | null };

export type InventoryDocumentCancelWithPendingScanMutationVariables = Exact<{
  uniqueInput: GoodsReceiveWhereUniqueInput;
  documentType?: InputMaybe<InventoryDocumentType>;
}>;


export type InventoryDocumentCancelWithPendingScanMutation = { __typename?: 'Mutation', InventoryDocumentCancelWithPendingScan?: { __typename?: 'InventoryDocumentCancelPendingScanOutput', unique_id: string } | null };

export type ItemCreateWithUomMutationVariables = Exact<{
  createInput: ItemCreateDirectInput;
}>;


export type ItemCreateWithUomMutation = { __typename?: 'Mutation', itemCreateWithUOM?: { __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null, sku_list: Array<{ __typename?: 'ItemSkuValue', item_unique_id?: string | null, sku_name: string, item_variant_value: Array<{ __typename?: 'ItemVariantValue', variant_key_name: string, variant_value_name: string }> }> } | null };

export type ItemDeleteMutationVariables = Exact<{
  uniqueInput: ItemWhereUniqueInput;
}>;


export type ItemDeleteMutation = { __typename?: 'Mutation', itemDelete?: { __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null } | null };

export type ItemQueryVariables = Exact<{
  uniqueInput: ItemWhereUniqueInput;
}>;


export type ItemQuery = { __typename?: 'Query', item?: { __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null, category_group?: string | null, main_category?: string | null, sub_category?: string | null, brand?: string | null, segment?: string | null, series?: string | null, purchase_standard_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, pre_sale?: boolean | null, tracability?: Tracability | null, barcode: string, sales_uom_id?: number | null, purchase_uom_id?: number | null, deliver_uom_id?: number | null, stock_uom_id?: number | null, uom_group_id?: number | null, min_stock_qty?: number | null, max_stock_qty?: number | null, reorder_point?: number | null, insurance_name?: string | null, insurance_detail?: string | null, customer_insurance_duration?: number | null, seller_insurance_duration?: number | null, attribute_list: Array<any>, selling_point_list: Array<any>, delivery_attribute?: { __typename?: 'DeliveryAttribute', id: number, width_uom_id?: number | null, length_uom_id?: number | null, thick_uom_id?: number | null, weight_uom_id?: number | null, height_uom_id?: number | null, volume_uom_id?: number | null, width?: number | null, length?: number | null, thick?: number | null, height?: number | null, weight?: number | null, volume?: number | null, width_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, length_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, height_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, weight_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null } | null, sales_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, purchase_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, deliver_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, stock_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, uom_group?: { __typename?: 'UomGroup', base_uom_id: number, unique_id: string, name: string, base_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string }, convertable_uom_list: Array<{ __typename?: 'Unit', id: number, name_th: string, unique_id: string }>, uom_conversion_list: Array<{ __typename?: 'UomConversion', base_uom_rate: number, target_uom_id: number, target_uom_rate: number, target_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } }> } | null, bundle_item_detail_list: Array<{ __typename?: 'BundleItemDetail', id: number, sorting_order?: number | null, bundle_item_id: string, item_unique_id: string, sku_name: string, sku_desc?: string | null, qty: number, ratio_percentage?: number | null, price?: number | null, special_price?: number | null, bundle_item: { __typename?: 'Item', id: number, unique_id: string, type?: ItemType | null, tracability?: Tracability | null, name: string, is_stockable?: boolean | null, barcode: string, purchase_standard_price?: number | null, sale_price?: number | null }, item: { __typename?: 'Item', tracability?: Tracability | null, type?: ItemType | null, purchase_standard_price?: number | null, is_stockable?: boolean | null, id: number, barcode: string }, item_sku_detail?: { __typename?: 'ItemSkuDetail', available_qty?: number | null, barcode?: string | null, sale_price?: number | null, sku_name: string, special_price?: number | null, stock_qty?: number | null } | null }>, item_variant_key_list: Array<{ __typename?: 'ItemVariantKey', variant_key_name: string, item_variant_value_list: Array<{ __typename?: 'ItemVariantValue', variant_value_name: string }> }>, sku_list: Array<{ __typename?: 'ItemSkuValue', item_unique_id?: string | null, sku_name: string, item_variant_value: Array<{ __typename?: 'ItemVariantValue', variant_key_name: string, variant_value_name: string }> }> } | null };

export type ItemSkuDetailQueryVariables = Exact<{
  uniqueInput?: InputMaybe<ItemSkuDetailUniqueInput>;
}>;


export type ItemSkuDetailQuery = { __typename?: 'Query', itemSkuDetail?: { __typename?: 'ItemSkuDetail', id: number, sku_name: string, item_unique_id: string, barcode?: string | null, sale_price?: number | null, special_price?: number | null, purchase_standard_price?: number | null, status?: number | null, img_url: Array<string>, total_sku_qty?: any | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, bundle_item_detail_list: Array<{ __typename?: 'BundleItemDetail', id: number, sorting_order?: number | null, bundle_item_id: string, item_unique_id: string, sku_name: string, sku_desc?: string | null, qty: number, ratio_percentage?: number | null, price?: number | null, special_price?: number | null, item: { __typename?: 'Item', id: number, unique_id: string, type?: ItemType | null, name: string, sale_price?: number | null, img_url: Array<string>, is_active: number, is_stockable?: boolean | null, tracability?: Tracability | null }, item_sku_detail?: { __typename?: 'ItemSkuDetail', sale_price?: number | null, purchase_standard_price?: number | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, status?: number | null } | null }>, item: { __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null, category_group?: string | null, main_category?: string | null, sub_category?: string | null, brand?: string | null, segment?: string | null, series?: string | null, purchase_standard_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, pre_sale?: boolean | null, tracability?: Tracability | null, barcode: string, sales_uom_id?: number | null, purchase_uom_id?: number | null, deliver_uom_id?: number | null, stock_uom_id?: number | null, uom_group_id?: number | null, min_stock_qty?: number | null, max_stock_qty?: number | null, replenishment_stock?: boolean | null, reorder_point?: number | null, insurance_name?: string | null, insurance_detail?: string | null, customer_insurance_duration?: number | null, seller_insurance_duration?: number | null, set_attribute?: any | null, attribute_list: Array<any>, selling_point_list: Array<any>, delivery_attribute?: { __typename?: 'DeliveryAttribute', width_uom_id?: number | null, length_uom_id?: number | null, weight_uom_id?: number | null, height_uom_id?: number | null, width?: number | null, length?: number | null, height?: number | null, weight?: number | null, width_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, length_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, height_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, weight_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null } | null, sales_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, purchase_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, deliver_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, stock_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, uom_group?: { __typename?: 'UomGroup', base_uom_id: number, unique_id: string, name: string, base_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string }, convertable_uom_list: Array<{ __typename?: 'Unit', id: number, name_th: string, unique_id: string }>, uom_conversion_list: Array<{ __typename?: 'UomConversion', base_uom_rate: number, target_uom_id: number, target_uom_rate: number, target_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } }> } | null, item_variant_key_list: Array<{ __typename?: 'ItemVariantKey', variant_key_name: string, item_variant_value_list: Array<{ __typename?: 'ItemVariantValue', variant_value_name: string }> }>, sku_list: Array<{ __typename?: 'ItemSkuValue', item_unique_id?: string | null, sku_name: string, item_variant_value: Array<{ __typename?: 'ItemVariantValue', variant_key_name: string, variant_value_name: string }>, sku_detail?: { __typename?: 'ItemSkuDetail', id: number, sku_name: string, item_unique_id: string, barcode?: string | null, sale_price?: number | null, special_price?: number | null, purchase_standard_price?: number | null, status?: number | null, img_url: Array<string>, total_sku_qty?: any | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null } | null }>, tag_list: Array<{ __typename?: 'Tag', id: number, name: string }>, bundle_item_detail_list: Array<{ __typename?: 'BundleItemDetail', id: number, sorting_order?: number | null, bundle_item_id: string, item_unique_id: string, sku_name: string, sku_desc?: string | null, qty: number, ratio_percentage?: number | null, price?: number | null, special_price?: number | null, item: { __typename?: 'Item', id: number, unique_id: string, type?: ItemType | null, name: string, sale_price?: number | null, special_price?: number | null, purchase_standard_price?: number | null, img_url: Array<string>, is_active: number, is_stockable?: boolean | null, tracability?: Tracability | null, stock_uom?: { __typename?: 'Unit', name_th: string } | null }, item_sku_detail?: { __typename?: 'ItemSkuDetail', img_url: Array<string>, sale_price?: number | null, purchase_standard_price?: number | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, status?: number | null, item_sku_qty?: Array<{ __typename?: 'ItemSkuQty', sku_name: string, stock_qty: number, available_qty: number, item_unique_id?: string | null, warehouse?: { __typename?: 'Warehouse', branch_id: number, unique_id: string, name: string, branch: { __typename?: 'Branch', unique_id: string, name: string } } | null, bin_location?: { __typename?: 'BinLocation', id: number, name: string } | null }> | null } | null, bundle_item: { __typename?: 'Item', name: string } }> } } | null };

export type ItemSkuQtyBySkuViewQueryVariables = Exact<{
  skuName: Scalars['String']['input'];
}>;


export type ItemSkuQtyBySkuViewQuery = { __typename?: 'Query', ItemSkuQtyBySkuView?: { __typename?: 'ItemSkuQtyBySkuView', sku_name: string, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, transit_qty?: number | null, sale_committed_qty?: number | null } | null };

export type ItemSkuQtysByBranchViewQueryVariables = Exact<{
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
}>;


export type ItemSkuQtysByBranchViewQuery = { __typename?: 'Query', ItemSkuQtysByBranchView?: { __typename?: 'ItemSkuQtyByBranchViewAggrid', count: number, results: Array<{ __typename?: 'ItemSkuQtyByBranchView', item_id?: number | null, item_unique_id?: string | null, sku_name?: string | null, item_name?: string | null, branch_id: number, branch_unique_id?: string | null, branch_name?: string | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, transit_qty?: number | null, sale_committed_qty?: number | null }> } | null };

export type ItemSkuQtysQueryVariables = Exact<{
  findManyInput?: InputMaybe<ItemSkuQtyFindManyInput>;
}>;


export type ItemSkuQtysQuery = { __typename?: 'Query', itemSkuQtys?: Array<{ __typename?: 'ItemSkuQty', id: number, warehouse_id?: number | null, bin_name?: string | null, bin_id?: number | null, sku_name: string, barcode: string, serial_no?: string | null, lot_date?: any | null, stock_qty: number, available_qty: number, purchase_ordered_qty: number, transit_qty: number, sale_committed_qty: number, warehouse?: { __typename?: 'Warehouse', unique_id: string } | null, bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null, item_sku_detail?: { __typename?: 'ItemSkuDetail', barcode?: string | null, img_url: Array<string>, item: { __typename?: 'Item', name: string, tracability?: Tracability | null, stock_uom?: { __typename?: 'Unit', name_en?: string | null, unique_id: string, id: number } | null } } | null } | null> | null };

export type ItemUpdateWithSkuMutationVariables = Exact<{
  uniqueInput: ItemWhereUniqueInput;
  updateInput: ItemUpdateWithSkuInput;
}>;


export type ItemUpdateWithSkuMutation = { __typename?: 'Mutation', itemUpdateWithSku?: { __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null, sku_list: Array<{ __typename?: 'ItemSkuValue', item_unique_id?: string | null, sku_name: string, item_variant_value: Array<{ __typename?: 'ItemVariantValue', variant_key_name: string, variant_value_name: string }> }> } | null };

export type ItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'Item', id: number, unique_id: string, seller_unique_id: string, type?: ItemType | null, name: string, model?: string | null, description?: string | null, vendor_contact?: any | null, img_url: Array<string>, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, inactive_date?: any | null, remark_status?: string | null, created_date: any, created_by?: any | null, category_group?: string | null, main_category?: string | null, sub_category?: string | null, brand?: string | null, segment?: string | null, series?: string | null, purchase_standard_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, pre_sale?: boolean | null, tracability?: Tracability | null, barcode: string, sales_uom_id?: number | null, purchase_uom_id?: number | null, deliver_uom_id?: number | null, stock_uom_id?: number | null, uom_group_id?: number | null, min_stock_qty?: number | null, max_stock_qty?: number | null, reorder_point?: number | null, insurance_name?: string | null, insurance_detail?: string | null, customer_insurance_duration?: number | null, seller_insurance_duration?: number | null, attribute_list: Array<any>, selling_point_list: Array<any>, delivery_attribute?: { __typename?: 'DeliveryAttribute', id: number, width_uom_id?: number | null, length_uom_id?: number | null, thick_uom_id?: number | null, weight_uom_id?: number | null, height_uom_id?: number | null, volume_uom_id?: number | null, width?: number | null, length?: number | null, thick?: number | null, height?: number | null, weight?: number | null, volume?: number | null, width_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, length_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, height_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, weight_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null } | null, sales_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, purchase_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, deliver_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, stock_uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, uom_group?: { __typename?: 'UomGroup', base_uom_id: number, unique_id: string, name: string, base_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string }, convertable_uom_list: Array<{ __typename?: 'Unit', id: number, name_th: string, unique_id: string }>, uom_conversion_list: Array<{ __typename?: 'UomConversion', base_uom_rate: number, target_uom_id: number, target_uom_rate: number, target_uom: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } }> } | null, bundle_item_detail_list: Array<{ __typename?: 'BundleItemDetail', id: number, sorting_order?: number | null, bundle_item_id: string, item_unique_id: string, sku_name: string, sku_desc?: string | null, qty: number, ratio_percentage?: number | null, price?: number | null, special_price?: number | null, bundle_item: { __typename?: 'Item', id: number, unique_id: string, type?: ItemType | null, tracability?: Tracability | null, name: string, is_stockable?: boolean | null, barcode: string, purchase_standard_price?: number | null, sale_price?: number | null }, item: { __typename?: 'Item', tracability?: Tracability | null, type?: ItemType | null, purchase_standard_price?: number | null, is_stockable?: boolean | null, id: number, barcode: string }, item_sku_detail?: { __typename?: 'ItemSkuDetail', available_qty?: number | null, barcode?: string | null, sale_price?: number | null, sku_name: string, special_price?: number | null, stock_qty?: number | null } | null }>, item_variant_key_list: Array<{ __typename?: 'ItemVariantKey', variant_key_name: string, item_variant_value_list: Array<{ __typename?: 'ItemVariantValue', variant_value_name: string }> }>, sku_list: Array<{ __typename?: 'ItemSkuValue', item_unique_id?: string | null, sku_name: string, item_variant_value: Array<{ __typename?: 'ItemVariantValue', variant_key_name: string, variant_value_name: string }> }> }> | null };

export type ImportItemPriceListAllMutationVariables = Exact<{
  importInput: ItemPriceListAllImportInput;
}>;


export type ImportItemPriceListAllMutation = { __typename?: 'Mutation', ImportItemPriceListAll: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ImportItemPriceListByItemMutationVariables = Exact<{
  importInput: ItemPriceListByItemImportInput;
}>;


export type ImportItemPriceListByItemMutation = { __typename?: 'Mutation', ImportItemPriceListByItem: { __typename?: 'InventoryImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, jobId?: number | null, detail?: any | null } };

export type ItemPriceListCreateMutationVariables = Exact<{
  data: ItemPriceListCreateInput;
}>;


export type ItemPriceListCreateMutation = { __typename?: 'Mutation', ItemPriceListCreate: { __typename?: 'ItemPriceList', id: number, unique_id: string, type: string, name: string, sales_channel_id?: number | null, is_increase: number, currency?: string | null, description?: string | null, is_active: number, start_date?: any | null, end_date?: any | null, adjusted_price?: number | null, sales_channel?: { __typename?: 'SalesChannel', id: number, unique_id: string, name_en: string, name_th: string } | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } };

export type ItemPriceListDeleteMutationVariables = Exact<{
  uniqueInput: ItemPriceListUniqueInput;
}>;


export type ItemPriceListDeleteMutation = { __typename?: 'Mutation', ItemPriceListDelete: { __typename?: 'ItemPriceList', id: number, unique_id: string, name: string } };

export type ItemPriceListFindUniqueQueryVariables = Exact<{
  uniqueInput: ItemPriceListUniqueInput;
}>;


export type ItemPriceListFindUniqueQuery = { __typename?: 'Query', ItemPriceListFindUnique?: { __typename?: 'ItemPriceList', id: number, unique_id: string, type: string, name: string, sales_channel_id?: number | null, is_increase: number, currency?: string | null, description?: string | null, is_active: number, start_date?: any | null, end_date?: any | null, adjusted_price?: number | null, sales_channel?: { __typename?: 'SalesChannel', name_th: string, id: number, name_en: string, unique_id: string } | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null };

export type ItemPriceListFindAllQueryVariables = Exact<{
  filterInput?: InputMaybe<ItemPriceListFindAllInput>;
}>;


export type ItemPriceListFindAllQuery = { __typename?: 'Query', ItemPriceListFindAll?: Array<{ __typename?: 'ItemPriceList', id: number, unique_id: string, type: string, name: string, is_increase: number, currency?: string | null, description?: string | null, is_active: number, start_date?: any | null, end_date?: any | null, adjusted_price?: number | null, sales_channel_id?: number | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null> | null };

export type ItemPriceListUpdateMutationVariables = Exact<{
  uniqueInput: ItemPriceListUniqueInput;
  data: ItemPriceListUpdateInput;
}>;


export type ItemPriceListUpdateMutation = { __typename?: 'Mutation', ItemPriceListUpdate: { __typename?: 'ItemPriceList', id: number, unique_id: string, type: string, name: string, sales_channel_id?: number | null, is_increase: number, currency?: string | null, description?: string | null, is_active: number, start_date?: any | null, end_date?: any | null, adjusted_price?: number | null, sales_channel?: { __typename?: 'SalesChannel', id: number, unique_id: string, name_en: string, name_th: string } | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } };

export type TraceEntriesFindManyAggridQueryVariables = Exact<{
  aggridInput?: InputMaybe<AggridTemplateInput>;
}>;


export type TraceEntriesFindManyAggridQuery = { __typename?: 'Query', TraceEntriesFindManyAggrid?: { __typename?: 'TraceEntryAggridOutput', count?: number | null, results?: Array<{ __typename?: 'TraceEntry', unique_id: string, reference_unique_id?: string | null, is_stockable: boolean, type: InventoryDocumentType, item_unique_id: string, sku_name: string, item_name: string, item_img_url: Array<string>, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, posted_date?: any | null, created_date: any, lot_date?: any | null, manufactured_date?: any | null, expired_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, stock_qty?: number | null, serial_no?: string | null, status?: string | null, scanned_by?: any | null, destination_scanned_by?: any | null, destination_scanned_date?: any | null, reference_line_item?: { __typename?: 'InventoryReferenceLineItem', line_item_unique_id: string, line_item_document_type: string } | null, uom?: { __typename?: 'Unit', unique_id: string, id: number, name_th: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } | null };

export type WmsUniqueIdGenerateQueryVariables = Exact<{
  modelType: WmsModelType;
}>;


export type WmsUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };

export type GoodsReturnCreateMutationVariables = Exact<{
  createInput: GoodsReturnCreateInput;
}>;


export type GoodsReturnCreateMutation = { __typename?: 'Mutation', GoodsReturnCreate: { __typename?: 'GoodsReturn', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, po_reference_unique_id?: string | null, manufactured_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };

export type GoodsReturnQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsReturnWhereUniqueInput>;
}>;


export type GoodsReturnQuery = { __typename?: 'Query', GoodsReturn?: { __typename?: 'GoodsReturn', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, po_reference_unique_id?: string | null, manufactured_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } | null };

export type GoodsReturnUpdateMutationVariables = Exact<{
  updateInput: GoodsReturnUpdateInput;
  uniqueInput: GoodsReturnWhereUniqueInput;
}>;


export type GoodsReturnUpdateMutation = { __typename?: 'Mutation', GoodsReturnUpdate: { __typename?: 'GoodsReturn', id: number, unique_id: string, created_date: any, posted_date?: any | null, reference_unique_id?: string | null, branch_id: number, warehouse_id?: number | null, type?: string | null, main_status: string, sub_status?: string | null, flag_status: Array<string>, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list: Array<{ __typename?: 'TraceEntry', sku_name: string, unique_id: string, type: InventoryDocumentType, item_unique_id: string, item_img_url: Array<string>, item_name: string, qty: number, document_item_qty?: number | null, posted_qty?: number | null, uom_id?: number | null, cost_price?: number | null, discount?: number | null, additional_cost?: number | null, remark?: string | null, created_date: any, posted_date?: any | null, lot_date?: any | null, source_bin_location_id?: number | null, tracability: Tracability, barcode?: string | null, status?: string | null, serial_no?: string | null, scanned_by?: any | null, expired_date?: any | null, is_stockable: boolean, po_reference_unique_id?: string | null, manufactured_date?: any | null, reference_unique_id?: string | null, uom?: { __typename?: 'Unit', id: number, name_th: string, unique_id: string } | null, source_bin_location?: { __typename?: 'BinLocation', name: string, id: number } | null }>, branch: { __typename?: 'Branch', name: string, status: number, unique_id: string, is_hq: boolean }, warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null } };


export const GenerateInventoryExportDocument = `
    query GenerateInventoryExport($input: ExportGenerateInput) {
  GenerateExportedDataNoQueue(input: $input)
}
    `;
export const useGenerateInventoryExportQuery = <
      TData = GenerateInventoryExportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GenerateInventoryExportQueryVariables,
      options?: UseQueryOptions<GenerateInventoryExportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateInventoryExportQuery, TError, TData>(
      variables === undefined ? ['GenerateInventoryExport'] : ['GenerateInventoryExport', variables],
      fetcher<GenerateInventoryExportQuery, GenerateInventoryExportQueryVariables>(client, GenerateInventoryExportDocument, variables, headers),
      options
    );
export const GenerateInventoryReportNoQueueDocument = `
    query GenerateInventoryReportNoQueue($input: ReportGenerateInput!) {
  GenerateReportNoQueue(input: $input)
}
    `;
export const useGenerateInventoryReportNoQueueQuery = <
      TData = GenerateInventoryReportNoQueueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GenerateInventoryReportNoQueueQueryVariables,
      options?: UseQueryOptions<GenerateInventoryReportNoQueueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateInventoryReportNoQueueQuery, TError, TData>(
      ['GenerateInventoryReportNoQueue', variables],
      fetcher<GenerateInventoryReportNoQueueQuery, GenerateInventoryReportNoQueueQueryVariables>(client, GenerateInventoryReportNoQueueDocument, variables, headers),
      options
    );
export const GoodsAdjustCreateDocument = `
    mutation GoodsAdjustCreate($createInput: GoodsAdjustCreateInput!) {
  GoodsAdjustCreate(createInput: $createInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      destination_scanned_by
      destination_scanned_date
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approver_list
    reviewer_list
    approval_step
    remark
  }
}
    `;
export const useGoodsAdjustCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsAdjustCreateMutation, TError, GoodsAdjustCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsAdjustCreateMutation, TError, GoodsAdjustCreateMutationVariables, TContext>(
      ['GoodsAdjustCreate'],
      (variables?: GoodsAdjustCreateMutationVariables) => fetcher<GoodsAdjustCreateMutation, GoodsAdjustCreateMutationVariables>(client, GoodsAdjustCreateDocument, variables, headers)(),
      options
    );
export const GoodsAdjustDocument = `
    query GoodsAdjust($uniqueInput: GoodsAdjustWhereUniqueInput) {
  GoodsAdjust(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      destination_scanned_by
      destination_scanned_date
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    remark
  }
}
    `;
export const useGoodsAdjustQuery = <
      TData = GoodsAdjustQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsAdjustQueryVariables,
      options?: UseQueryOptions<GoodsAdjustQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsAdjustQuery, TError, TData>(
      variables === undefined ? ['GoodsAdjust'] : ['GoodsAdjust', variables],
      fetcher<GoodsAdjustQuery, GoodsAdjustQueryVariables>(client, GoodsAdjustDocument, variables, headers),
      options
    );
export const GoodsAdjustUpdateDocument = `
    mutation GoodsAdjustUpdate($updateInput: GoodsAdjustUpdateInput!, $uniqueInput: GoodsAdjustWhereUniqueInput!) {
  GoodsAdjustUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      destination_scanned_by
      destination_scanned_date
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    remark
  }
}
    `;
export const useGoodsAdjustUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsAdjustUpdateMutation, TError, GoodsAdjustUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsAdjustUpdateMutation, TError, GoodsAdjustUpdateMutationVariables, TContext>(
      ['GoodsAdjustUpdate'],
      (variables?: GoodsAdjustUpdateMutationVariables) => fetcher<GoodsAdjustUpdateMutation, GoodsAdjustUpdateMutationVariables>(client, GoodsAdjustUpdateDocument, variables, headers)(),
      options
    );
export const GoodsIssueCreateDocument = `
    mutation GoodsIssueCreate($createInput: GoodsIssueCreateInput!) {
  GoodsIssueCreate(createInput: $createInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      manufactured_date
      reference_unique_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
  }
}
    `;
export const useGoodsIssueCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsIssueCreateMutation, TError, GoodsIssueCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsIssueCreateMutation, TError, GoodsIssueCreateMutationVariables, TContext>(
      ['GoodsIssueCreate'],
      (variables?: GoodsIssueCreateMutationVariables) => fetcher<GoodsIssueCreateMutation, GoodsIssueCreateMutationVariables>(client, GoodsIssueCreateDocument, variables, headers)(),
      options
    );
export const GoodsIssueDocument = `
    query GoodsIssue($uniqueInput: GoodsIssueWhereUniqueInput) {
  GoodsIssue(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        id
        name
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
  }
}
    `;
export const useGoodsIssueQuery = <
      TData = GoodsIssueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsIssueQueryVariables,
      options?: UseQueryOptions<GoodsIssueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsIssueQuery, TError, TData>(
      variables === undefined ? ['GoodsIssue'] : ['GoodsIssue', variables],
      fetcher<GoodsIssueQuery, GoodsIssueQueryVariables>(client, GoodsIssueDocument, variables, headers),
      options
    );
export const GoodsIssueUpdateDocument = `
    mutation GoodsIssueUpdate($updateInput: GoodsIssueUpdateInput!, $uniqueInput: GoodsIssueWhereUniqueInput!) {
  GoodsIssueUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
  }
}
    `;
export const useGoodsIssueUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsIssueUpdateMutation, TError, GoodsIssueUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsIssueUpdateMutation, TError, GoodsIssueUpdateMutationVariables, TContext>(
      ['GoodsIssueUpdate'],
      (variables?: GoodsIssueUpdateMutationVariables) => fetcher<GoodsIssueUpdateMutation, GoodsIssueUpdateMutationVariables>(client, GoodsIssueUpdateDocument, variables, headers)(),
      options
    );
export const GoodsReceiveCreateDocument = `
    mutation GoodsReceiveCreate($createInput: GoodsReceiveCreateInput!) {
  GoodsReceiveCreate(createInput: $createInput) {
    id
    unique_id
    reference_unique_id_list
    created_date
    posted_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    branch_id
    type
    aggrid_status
    main_status
    sub_status
    flag_status
    remark
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      reference_unique_id
      po_reference_unique_id
      expired_date
      is_stockable
      manufactured_date
      expired_date
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
  }
}
    `;
export const useGoodsReceiveCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReceiveCreateMutation, TError, GoodsReceiveCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReceiveCreateMutation, TError, GoodsReceiveCreateMutationVariables, TContext>(
      ['GoodsReceiveCreate'],
      (variables?: GoodsReceiveCreateMutationVariables) => fetcher<GoodsReceiveCreateMutation, GoodsReceiveCreateMutationVariables>(client, GoodsReceiveCreateDocument, variables, headers)(),
      options
    );
export const GoodsReceiveDocument = `
    query GoodsReceive($uniqueInput: GoodsReceiveWhereUniqueInput) {
  GoodsReceive(uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_unique_id_list
    created_date
    posted_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    branch_id
    branch {
      id
      unique_id
      name
    }
    type
    aggrid_status
    main_status
    sub_status
    flag_status
    remark
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      reference_unique_id
      po_reference_unique_id
      expired_date
      is_stockable
      manufactured_date
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
  }
}
    `;
export const useGoodsReceiveQuery = <
      TData = GoodsReceiveQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsReceiveQueryVariables,
      options?: UseQueryOptions<GoodsReceiveQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsReceiveQuery, TError, TData>(
      variables === undefined ? ['GoodsReceive'] : ['GoodsReceive', variables],
      fetcher<GoodsReceiveQuery, GoodsReceiveQueryVariables>(client, GoodsReceiveDocument, variables, headers),
      options
    );
export const GoodsReceiveUpdateDocument = `
    mutation GoodsReceiveUpdate($updateInput: GoodsReceiveUpdateInput!, $uniqueInput: GoodsReceiveWhereUniqueInput!) {
  GoodsReceiveUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_unique_id_list
    created_date
    posted_date
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    branch_id
    type
    aggrid_status
    main_status
    sub_status
    flag_status
    remark
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      reference_unique_id
      po_reference_unique_id
      expired_date
      is_stockable
      manufactured_date
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
  }
}
    `;
export const useGoodsReceiveUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReceiveUpdateMutation, TError, GoodsReceiveUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReceiveUpdateMutation, TError, GoodsReceiveUpdateMutationVariables, TContext>(
      ['GoodsReceiveUpdate'],
      (variables?: GoodsReceiveUpdateMutationVariables) => fetcher<GoodsReceiveUpdateMutation, GoodsReceiveUpdateMutationVariables>(client, GoodsReceiveUpdateDocument, variables, headers)(),
      options
    );
export const GoodsTransferCreateDocument = `
    mutation GoodsTransferCreate($createInput: GoodsTransferCreateInput!) {
  GoodsTransferCreate(createInput: $createInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      manufactured_date
      reference_unique_id
    }
    source_branch_id
    source_branch {
      name
      status
      unique_id
      is_hq
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    destination_branch_id
    destination_branch {
      name
      status
      unique_id
      is_hq
    }
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
    consignment_bin_location_id
  }
}
    `;
export const useGoodsTransferCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsTransferCreateMutation, TError, GoodsTransferCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsTransferCreateMutation, TError, GoodsTransferCreateMutationVariables, TContext>(
      ['GoodsTransferCreate'],
      (variables?: GoodsTransferCreateMutationVariables) => fetcher<GoodsTransferCreateMutation, GoodsTransferCreateMutationVariables>(client, GoodsTransferCreateDocument, variables, headers)(),
      options
    );
export const GoodsTransferDocument = `
    query GoodsTransfer($uniqueInput: GoodsTransferWhereUniqueInput) {
  GoodsTransfer(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      destination_scanned_by
      destination_scanned_date
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
    }
    source_branch_id
    source_branch {
      name
      status
      unique_id
      is_hq
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    destination_branch_id
    destination_branch {
      name
      status
      unique_id
      is_hq
    }
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
    consignment_bin_location_id
  }
}
    `;
export const useGoodsTransferQuery = <
      TData = GoodsTransferQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsTransferQueryVariables,
      options?: UseQueryOptions<GoodsTransferQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsTransferQuery, TError, TData>(
      variables === undefined ? ['GoodsTransfer'] : ['GoodsTransfer', variables],
      fetcher<GoodsTransferQuery, GoodsTransferQueryVariables>(client, GoodsTransferDocument, variables, headers),
      options
    );
export const GoodsTransferUpdateDocument = `
    mutation GoodsTransferUpdate($updateInput: GoodsTransferUpdateInput!, $uniqueInput: GoodsTransferWhereUniqueInput!) {
  GoodsTransferUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      stock_qty
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      tracability
      barcode
      status
      serial_no
      scanned_by
      is_stockable
      manufactured_date
      expired_date
      reference_unique_id
    }
    source_branch_id
    source_branch {
      name
      status
      unique_id
      is_hq
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    destination_branch_id
    destination_branch {
      name
      status
      unique_id
      is_hq
    }
    destination_warehouse_id
    destination_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    reviewer_list
    approver_list
    remark
    consignment_bin_location_id
  }
}
    `;
export const useGoodsTransferUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsTransferUpdateMutation, TError, GoodsTransferUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsTransferUpdateMutation, TError, GoodsTransferUpdateMutationVariables, TContext>(
      ['GoodsTransferUpdate'],
      (variables?: GoodsTransferUpdateMutationVariables) => fetcher<GoodsTransferUpdateMutation, GoodsTransferUpdateMutationVariables>(client, GoodsTransferUpdateDocument, variables, headers)(),
      options
    );
export const ImportBundleItemsDocument = `
    mutation ImportBundleItems($importInput: ItemBundleImportInput!) {
  ImportBundleItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportBundleItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportBundleItemsMutation, TError, ImportBundleItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportBundleItemsMutation, TError, ImportBundleItemsMutationVariables, TContext>(
      ['ImportBundleItems'],
      (variables?: ImportBundleItemsMutationVariables) => fetcher<ImportBundleItemsMutation, ImportBundleItemsMutationVariables>(client, ImportBundleItemsDocument, variables, headers)(),
      options
    );
export const ImportItemImagesDocument = `
    mutation ImportItemImages($importInput: ItemImageImportInput!) {
  ImportItemImages(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemImagesMutation, TError, ImportItemImagesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemImagesMutation, TError, ImportItemImagesMutationVariables, TContext>(
      ['ImportItemImages'],
      (variables?: ImportItemImagesMutationVariables) => fetcher<ImportItemImagesMutation, ImportItemImagesMutationVariables>(client, ImportItemImagesDocument, variables, headers)(),
      options
    );
export const ImportItemInBundlesDocument = `
    mutation ImportItemInBundles($importInput: ItemInBundleImportInput!) {
  ImportItemInBundles(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemInBundlesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemInBundlesMutation, TError, ImportItemInBundlesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemInBundlesMutation, TError, ImportItemInBundlesMutationVariables, TContext>(
      ['ImportItemInBundles'],
      (variables?: ImportItemInBundlesMutationVariables) => fetcher<ImportItemInBundlesMutation, ImportItemInBundlesMutationVariables>(client, ImportItemInBundlesDocument, variables, headers)(),
      options
    );
export const ImportItemStockLimitDocument = `
    mutation ImportItemStockLimit($importInput: ItemStockLimitImportInput!) {
  ImportItemStockLimit(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemStockLimitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemStockLimitMutation, TError, ImportItemStockLimitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemStockLimitMutation, TError, ImportItemStockLimitMutationVariables, TContext>(
      ['ImportItemStockLimit'],
      (variables?: ImportItemStockLimitMutationVariables) => fetcher<ImportItemStockLimitMutation, ImportItemStockLimitMutationVariables>(client, ImportItemStockLimitDocument, variables, headers)(),
      options
    );
export const ImportItemVariantPriceDocument = `
    mutation ImportItemVariantPrice($importInput: ItemVariantPriceImportInput!) {
  ImportItemVariantPrice(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemVariantPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemVariantPriceMutation, TError, ImportItemVariantPriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemVariantPriceMutation, TError, ImportItemVariantPriceMutationVariables, TContext>(
      ['ImportItemVariantPrice'],
      (variables?: ImportItemVariantPriceMutationVariables) => fetcher<ImportItemVariantPriceMutation, ImportItemVariantPriceMutationVariables>(client, ImportItemVariantPriceDocument, variables, headers)(),
      options
    );
export const ImportItemVariantValueDocument = `
    mutation ImportItemVariantValue($importInput: ItemVariantValueImportInput!) {
  ImportItemVariantValue(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemVariantValueMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemVariantValueMutation, TError, ImportItemVariantValueMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemVariantValueMutation, TError, ImportItemVariantValueMutationVariables, TContext>(
      ['ImportItemVariantValue'],
      (variables?: ImportItemVariantValueMutationVariables) => fetcher<ImportItemVariantValueMutation, ImportItemVariantValueMutationVariables>(client, ImportItemVariantValueDocument, variables, headers)(),
      options
    );
export const ImportNormalItemsDocument = `
    mutation ImportNormalItems($importInput: ItemNormalImportInput!) {
  ImportNormalItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportNormalItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportNormalItemsMutation, TError, ImportNormalItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportNormalItemsMutation, TError, ImportNormalItemsMutationVariables, TContext>(
      ['ImportNormalItems'],
      (variables?: ImportNormalItemsMutationVariables) => fetcher<ImportNormalItemsMutation, ImportNormalItemsMutationVariables>(client, ImportNormalItemsDocument, variables, headers)(),
      options
    );
export const ImportServiceItemsDocument = `
    mutation ImportServiceItems($importInput: ItemServiceImportInput!) {
  ImportServiceItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportServiceItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportServiceItemsMutation, TError, ImportServiceItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportServiceItemsMutation, TError, ImportServiceItemsMutationVariables, TContext>(
      ['ImportServiceItems'],
      (variables?: ImportServiceItemsMutationVariables) => fetcher<ImportServiceItemsMutation, ImportServiceItemsMutationVariables>(client, ImportServiceItemsDocument, variables, headers)(),
      options
    );
export const ImportVariantItemsDocument = `
    mutation ImportVariantItems($importInput: ItemVariantImportInput!) {
  ImportVariantItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportVariantItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportVariantItemsMutation, TError, ImportVariantItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportVariantItemsMutation, TError, ImportVariantItemsMutationVariables, TContext>(
      ['ImportVariantItems'],
      (variables?: ImportVariantItemsMutationVariables) => fetcher<ImportVariantItemsMutation, ImportVariantItemsMutationVariables>(client, ImportVariantItemsDocument, variables, headers)(),
      options
    );
export const ValidateItemImportDocument = `
    query ValidateItemImport($validateInput: ItemInputValidateInput!) {
  ValidateItemImport(validateInput: $validateInput) {
    existing_item_unique_id_list
    missing_item_unique_id_list
    existing_sku_name_list
    missing_sku_name_list
    existing_barcode_list
    missing_uom_unique_id_list
    missing_branch_unique_id_list
    missing_warehouse_unique_id_list
    missing_item_price_list_unique_id_list
    existing_item_price_list_unique_id_list
    missing_sales_channel_list
    missing_vendor_unique_id_list
    missing_category_group_list
    missing_main_category_list
    missing_sub_category_list
    missing_brand_list
    missing_segment_list
    missing_series_list
    missing_model_list
  }
}
    `;
export const useValidateItemImportQuery = <
      TData = ValidateItemImportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateItemImportQueryVariables,
      options?: UseQueryOptions<ValidateItemImportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateItemImportQuery, TError, TData>(
      ['ValidateItemImport', variables],
      fetcher<ValidateItemImportQuery, ValidateItemImportQueryVariables>(client, ValidateItemImportDocument, variables, headers),
      options
    );
export const InventoryDocumentCancelDocument = `
    mutation InventoryDocumentCancel($uniqueInput: GoodsReceiveWhereUniqueInput!, $documentType: InventoryDocumentType) {
  InventoryDocumentCancel(uniqueInput: $uniqueInput, documentType: $documentType) {
    unique_id
  }
}
    `;
export const useInventoryDocumentCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InventoryDocumentCancelMutation, TError, InventoryDocumentCancelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InventoryDocumentCancelMutation, TError, InventoryDocumentCancelMutationVariables, TContext>(
      ['InventoryDocumentCancel'],
      (variables?: InventoryDocumentCancelMutationVariables) => fetcher<InventoryDocumentCancelMutation, InventoryDocumentCancelMutationVariables>(client, InventoryDocumentCancelDocument, variables, headers)(),
      options
    );
export const InventoryDocumentCancelWithPendingScanDocument = `
    mutation InventoryDocumentCancelWithPendingScan($uniqueInput: GoodsReceiveWhereUniqueInput!, $documentType: InventoryDocumentType) {
  InventoryDocumentCancelWithPendingScan(
    uniqueInput: $uniqueInput
    documentType: $documentType
  ) {
    unique_id
  }
}
    `;
export const useInventoryDocumentCancelWithPendingScanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InventoryDocumentCancelWithPendingScanMutation, TError, InventoryDocumentCancelWithPendingScanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InventoryDocumentCancelWithPendingScanMutation, TError, InventoryDocumentCancelWithPendingScanMutationVariables, TContext>(
      ['InventoryDocumentCancelWithPendingScan'],
      (variables?: InventoryDocumentCancelWithPendingScanMutationVariables) => fetcher<InventoryDocumentCancelWithPendingScanMutation, InventoryDocumentCancelWithPendingScanMutationVariables>(client, InventoryDocumentCancelWithPendingScanDocument, variables, headers)(),
      options
    );
export const ItemCreateWithUomDocument = `
    mutation ItemCreateWithUOM($createInput: ItemCreateDirectInput!) {
  itemCreateWithUOM(createInput: $createInput) {
    id
    unique_id
    seller_unique_id
    type
    name
    model
    description
    vendor_contact
    img_url
    is_purchasable
    is_saleable
    is_stockable
    is_active
    inactive_date
    remark_status
    created_date
    created_by
    sku_list {
      item_unique_id
      item_variant_value {
        variant_key_name
        variant_value_name
      }
      sku_name
    }
  }
}
    `;
export const useItemCreateWithUomMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemCreateWithUomMutation, TError, ItemCreateWithUomMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemCreateWithUomMutation, TError, ItemCreateWithUomMutationVariables, TContext>(
      ['ItemCreateWithUOM'],
      (variables?: ItemCreateWithUomMutationVariables) => fetcher<ItemCreateWithUomMutation, ItemCreateWithUomMutationVariables>(client, ItemCreateWithUomDocument, variables, headers)(),
      options
    );
export const ItemDeleteDocument = `
    mutation ItemDelete($uniqueInput: ItemWhereUniqueInput!) {
  itemDelete(uniqueInput: $uniqueInput) {
    id
    unique_id
    seller_unique_id
    type
    name
    model
    description
    vendor_contact
    img_url
    is_purchasable
    is_saleable
    is_stockable
    is_active
    inactive_date
    remark_status
    created_date
    created_by
  }
}
    `;
export const useItemDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemDeleteMutation, TError, ItemDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemDeleteMutation, TError, ItemDeleteMutationVariables, TContext>(
      ['ItemDelete'],
      (variables?: ItemDeleteMutationVariables) => fetcher<ItemDeleteMutation, ItemDeleteMutationVariables>(client, ItemDeleteDocument, variables, headers)(),
      options
    );
export const ItemDocument = `
    query Item($uniqueInput: ItemWhereUniqueInput!) {
  item(uniqueInput: $uniqueInput) {
    id
    unique_id
    seller_unique_id
    type
    name
    model
    description
    vendor_contact
    img_url
    is_purchasable
    is_saleable
    is_stockable
    is_active
    inactive_date
    remark_status
    created_date
    created_by
    category_group
    main_category
    sub_category
    brand
    segment
    series
    delivery_attribute {
      id
      width_uom {
        id
        name_th
        unique_id
      }
      length_uom {
        id
        name_th
        unique_id
      }
      height_uom {
        id
        name_th
        unique_id
      }
      weight_uom {
        id
        name_th
        unique_id
      }
      width_uom_id
      length_uom_id
      thick_uom_id
      weight_uom_id
      height_uom_id
      volume_uom_id
      width
      length
      thick
      height
      weight
      volume
    }
    purchase_standard_price
    min_purchase_request_qty
    purchase_vat_type
    sale_price
    special_price
    sale_vat_type
    pre_sale
    tracability
    barcode
    sales_uom_id
    purchase_uom_id
    deliver_uom_id
    stock_uom_id
    sales_uom {
      id
      name_th
      unique_id
    }
    purchase_uom {
      id
      name_th
      unique_id
    }
    deliver_uom {
      id
      name_th
      unique_id
    }
    stock_uom {
      id
      name_th
      unique_id
    }
    uom_group_id
    uom_group {
      base_uom {
        id
        name_th
        unique_id
      }
      base_uom_id
      unique_id
      name
      convertable_uom_list {
        id
        name_th
        unique_id
      }
      uom_conversion_list {
        base_uom_rate
        target_uom {
          id
          name_th
          unique_id
        }
        target_uom_id
        target_uom_rate
      }
    }
    min_stock_qty
    max_stock_qty
    reorder_point
    insurance_name
    insurance_detail
    customer_insurance_duration
    seller_insurance_duration
    attribute_list
    selling_point_list
    bundle_item_detail_list {
      id
      sorting_order
      bundle_item_id
      bundle_item {
        id
        unique_id
        type
        tracability
        name
        is_stockable
        barcode
        purchase_standard_price
        sale_price
      }
      item_unique_id
      item {
        tracability
        type
        purchase_standard_price
        is_stockable
        id
        barcode
      }
      sku_name
      item_sku_detail {
        available_qty
        barcode
        sale_price
        sku_name
        special_price
        stock_qty
      }
      sku_desc
      qty
      ratio_percentage
      price
      special_price
    }
    item_variant_key_list {
      variant_key_name
      item_variant_value_list {
        variant_value_name
      }
    }
    sku_list {
      item_unique_id
      item_variant_value {
        variant_key_name
        variant_value_name
      }
      sku_name
    }
  }
}
    `;
export const useItemQuery = <
      TData = ItemQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemQueryVariables,
      options?: UseQueryOptions<ItemQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemQuery, TError, TData>(
      ['Item', variables],
      fetcher<ItemQuery, ItemQueryVariables>(client, ItemDocument, variables, headers),
      options
    );
export const ItemSkuDetailDocument = `
    query ItemSkuDetail($uniqueInput: ItemSkuDetailUniqueInput) {
  itemSkuDetail(uniqueInput: $uniqueInput) {
    id
    sku_name
    item_unique_id
    barcode
    sale_price
    special_price
    purchase_standard_price
    status
    img_url
    total_sku_qty
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
    bundle_item_detail_list {
      id
      sorting_order
      bundle_item_id
      item_unique_id
      item {
        id
        unique_id
        type
        name
        sale_price
        img_url
        is_active
        is_stockable
        tracability
      }
      sku_name
      item_sku_detail {
        sale_price
        purchase_standard_price
        stock_qty
        available_qty
        purchase_ordered_qty
        sale_committed_qty
        status
      }
      sku_desc
      qty
      ratio_percentage
      price
      special_price
    }
    item {
      id
      unique_id
      seller_unique_id
      type
      name
      model
      description
      vendor_contact
      img_url
      is_purchasable
      is_saleable
      is_stockable
      is_active
      inactive_date
      remark_status
      created_date
      created_by
      category_group
      main_category
      sub_category
      brand
      segment
      series
      delivery_attribute {
        width_uom {
          id
          name_th
          unique_id
        }
        length_uom {
          id
          name_th
          unique_id
        }
        height_uom {
          id
          name_th
          unique_id
        }
        weight_uom {
          id
          name_th
          unique_id
        }
        width_uom_id
        length_uom_id
        weight_uom_id
        height_uom_id
        width
        length
        height
        weight
      }
      purchase_standard_price
      min_purchase_request_qty
      purchase_vat_type
      sale_price
      special_price
      sale_vat_type
      pre_sale
      tracability
      barcode
      sales_uom_id
      purchase_uom_id
      deliver_uom_id
      stock_uom_id
      sales_uom {
        id
        name_th
        unique_id
      }
      purchase_uom {
        id
        name_th
        unique_id
      }
      deliver_uom {
        id
        name_th
        unique_id
      }
      stock_uom {
        id
        name_th
        unique_id
      }
      uom_group_id
      uom_group {
        base_uom {
          id
          name_th
          unique_id
        }
        base_uom_id
        unique_id
        name
        convertable_uom_list {
          id
          name_th
          unique_id
        }
        uom_conversion_list {
          base_uom_rate
          target_uom {
            id
            name_th
            unique_id
          }
          target_uom_id
          target_uom_rate
        }
      }
      min_stock_qty
      max_stock_qty
      replenishment_stock
      reorder_point
      insurance_name
      insurance_detail
      customer_insurance_duration
      seller_insurance_duration
      set_attribute
      attribute_list
      selling_point_list
      item_variant_key_list {
        variant_key_name
        item_variant_value_list {
          variant_value_name
        }
      }
      sku_list {
        item_unique_id
        item_variant_value {
          variant_key_name
          variant_value_name
        }
        sku_name
        sku_detail {
          id
          sku_name
          item_unique_id
          barcode
          sale_price
          special_price
          purchase_standard_price
          status
          img_url
          total_sku_qty
          stock_qty
          available_qty
          purchase_ordered_qty
          sale_committed_qty
        }
      }
      tag_list {
        id
        name
      }
      bundle_item_detail_list {
        id
        sorting_order
        bundle_item_id
        item_unique_id
        item {
          id
          unique_id
          type
          name
          sale_price
          special_price
          purchase_standard_price
          stock_uom {
            name_th
          }
          img_url
          is_active
          is_stockable
          tracability
        }
        sku_name
        item_sku_detail {
          img_url
          sale_price
          purchase_standard_price
          stock_qty
          available_qty
          purchase_ordered_qty
          sale_committed_qty
          status
          item_sku_qty {
            sku_name
            stock_qty
            available_qty
            warehouse {
              branch_id
              branch {
                unique_id
                name
              }
              unique_id
              name
            }
            item_unique_id
            bin_location {
              id
              name
            }
          }
        }
        sku_desc
        qty
        ratio_percentage
        price
        special_price
        bundle_item {
          name
        }
      }
    }
  }
}
    `;
export const useItemSkuDetailQuery = <
      TData = ItemSkuDetailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemSkuDetailQueryVariables,
      options?: UseQueryOptions<ItemSkuDetailQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuDetailQuery, TError, TData>(
      variables === undefined ? ['ItemSkuDetail'] : ['ItemSkuDetail', variables],
      fetcher<ItemSkuDetailQuery, ItemSkuDetailQueryVariables>(client, ItemSkuDetailDocument, variables, headers),
      options
    );
export const ItemSkuQtyBySkuViewDocument = `
    query ItemSkuQtyBySkuView($skuName: String!) {
  ItemSkuQtyBySkuView(skuName: $skuName) {
    sku_name
    stock_qty
    available_qty
    purchase_ordered_qty
    transit_qty
    sale_committed_qty
  }
}
    `;
export const useItemSkuQtyBySkuViewQuery = <
      TData = ItemSkuQtyBySkuViewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemSkuQtyBySkuViewQueryVariables,
      options?: UseQueryOptions<ItemSkuQtyBySkuViewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuQtyBySkuViewQuery, TError, TData>(
      ['ItemSkuQtyBySkuView', variables],
      fetcher<ItemSkuQtyBySkuViewQuery, ItemSkuQtyBySkuViewQueryVariables>(client, ItemSkuQtyBySkuViewDocument, variables, headers),
      options
    );
export const ItemSkuQtysByBranchViewDocument = `
    query ItemSkuQtysByBranchView($aggridInput: AnyAggridInput) {
  ItemSkuQtysByBranchView(aggridInput: $aggridInput) {
    count
    results {
      item_id
      item_unique_id
      sku_name
      item_name
      branch_id
      branch_unique_id
      branch_name
      stock_qty
      available_qty
      purchase_ordered_qty
      transit_qty
      sale_committed_qty
    }
  }
}
    `;
export const useItemSkuQtysByBranchViewQuery = <
      TData = ItemSkuQtysByBranchViewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemSkuQtysByBranchViewQueryVariables,
      options?: UseQueryOptions<ItemSkuQtysByBranchViewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuQtysByBranchViewQuery, TError, TData>(
      variables === undefined ? ['ItemSkuQtysByBranchView'] : ['ItemSkuQtysByBranchView', variables],
      fetcher<ItemSkuQtysByBranchViewQuery, ItemSkuQtysByBranchViewQueryVariables>(client, ItemSkuQtysByBranchViewDocument, variables, headers),
      options
    );
export const ItemSkuQtysDocument = `
    query ItemSkuQtys($findManyInput: ItemSkuQtyFindManyInput) {
  itemSkuQtys(findManyInput: $findManyInput) {
    id
    warehouse_id
    warehouse {
      unique_id
    }
    bin_name
    bin_id
    bin_location {
      name
      id
    }
    sku_name
    barcode
    serial_no
    lot_date
    item_sku_detail {
      barcode
      img_url
      item {
        name
        tracability
        stock_uom {
          name_en
          unique_id
          id
        }
      }
    }
    stock_qty
    available_qty
    purchase_ordered_qty
    transit_qty
    sale_committed_qty
  }
}
    `;
export const useItemSkuQtysQuery = <
      TData = ItemSkuQtysQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemSkuQtysQueryVariables,
      options?: UseQueryOptions<ItemSkuQtysQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuQtysQuery, TError, TData>(
      variables === undefined ? ['ItemSkuQtys'] : ['ItemSkuQtys', variables],
      fetcher<ItemSkuQtysQuery, ItemSkuQtysQueryVariables>(client, ItemSkuQtysDocument, variables, headers),
      options
    );
export const ItemUpdateWithSkuDocument = `
    mutation ItemUpdateWithSku($uniqueInput: ItemWhereUniqueInput!, $updateInput: ItemUpdateWithSkuInput!) {
  itemUpdateWithSku(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    seller_unique_id
    type
    name
    model
    description
    vendor_contact
    img_url
    is_purchasable
    is_saleable
    is_stockable
    is_active
    inactive_date
    remark_status
    created_date
    created_by
    sku_list {
      item_unique_id
      item_variant_value {
        variant_key_name
        variant_value_name
      }
      sku_name
    }
  }
}
    `;
export const useItemUpdateWithSkuMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemUpdateWithSkuMutation, TError, ItemUpdateWithSkuMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemUpdateWithSkuMutation, TError, ItemUpdateWithSkuMutationVariables, TContext>(
      ['ItemUpdateWithSku'],
      (variables?: ItemUpdateWithSkuMutationVariables) => fetcher<ItemUpdateWithSkuMutation, ItemUpdateWithSkuMutationVariables>(client, ItemUpdateWithSkuDocument, variables, headers)(),
      options
    );
export const ItemsDocument = `
    query Items {
  items {
    id
    unique_id
    seller_unique_id
    type
    name
    model
    description
    vendor_contact
    img_url
    is_purchasable
    is_saleable
    is_stockable
    is_active
    inactive_date
    remark_status
    created_date
    created_by
    category_group
    main_category
    sub_category
    brand
    segment
    series
    delivery_attribute {
      id
      width_uom {
        id
        name_th
        unique_id
      }
      length_uom {
        id
        name_th
        unique_id
      }
      height_uom {
        id
        name_th
        unique_id
      }
      weight_uom {
        id
        name_th
        unique_id
      }
      width_uom_id
      length_uom_id
      thick_uom_id
      weight_uom_id
      height_uom_id
      volume_uom_id
      width
      length
      thick
      height
      weight
      volume
    }
    purchase_standard_price
    min_purchase_request_qty
    purchase_vat_type
    sale_price
    special_price
    sale_vat_type
    pre_sale
    tracability
    barcode
    sales_uom_id
    purchase_uom_id
    deliver_uom_id
    stock_uom_id
    sales_uom {
      id
      name_th
      unique_id
    }
    purchase_uom {
      id
      name_th
      unique_id
    }
    deliver_uom {
      id
      name_th
      unique_id
    }
    stock_uom {
      id
      name_th
      unique_id
    }
    uom_group_id
    uom_group {
      base_uom {
        id
        name_th
        unique_id
      }
      base_uom_id
      unique_id
      name
      convertable_uom_list {
        id
        name_th
        unique_id
      }
      uom_conversion_list {
        base_uom_rate
        target_uom {
          id
          name_th
          unique_id
        }
        target_uom_id
        target_uom_rate
      }
    }
    min_stock_qty
    max_stock_qty
    reorder_point
    insurance_name
    insurance_detail
    customer_insurance_duration
    seller_insurance_duration
    attribute_list
    selling_point_list
    bundle_item_detail_list {
      id
      sorting_order
      bundle_item_id
      bundle_item {
        id
        unique_id
        type
        tracability
        name
        is_stockable
        barcode
        purchase_standard_price
        sale_price
      }
      item_unique_id
      item {
        tracability
        type
        purchase_standard_price
        is_stockable
        id
        barcode
      }
      sku_name
      item_sku_detail {
        available_qty
        barcode
        sale_price
        sku_name
        special_price
        stock_qty
      }
      sku_desc
      qty
      ratio_percentage
      price
      special_price
    }
    item_variant_key_list {
      variant_key_name
      item_variant_value_list {
        variant_value_name
      }
    }
    sku_list {
      item_unique_id
      item_variant_value {
        variant_key_name
        variant_value_name
      }
      sku_name
    }
  }
}
    `;
export const useItemsQuery = <
      TData = ItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemsQueryVariables,
      options?: UseQueryOptions<ItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemsQuery, TError, TData>(
      variables === undefined ? ['Items'] : ['Items', variables],
      fetcher<ItemsQuery, ItemsQueryVariables>(client, ItemsDocument, variables, headers),
      options
    );
export const ImportItemPriceListAllDocument = `
    mutation ImportItemPriceListAll($importInput: ItemPriceListAllImportInput!) {
  ImportItemPriceListAll(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemPriceListAllMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemPriceListAllMutation, TError, ImportItemPriceListAllMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemPriceListAllMutation, TError, ImportItemPriceListAllMutationVariables, TContext>(
      ['ImportItemPriceListAll'],
      (variables?: ImportItemPriceListAllMutationVariables) => fetcher<ImportItemPriceListAllMutation, ImportItemPriceListAllMutationVariables>(client, ImportItemPriceListAllDocument, variables, headers)(),
      options
    );
export const ImportItemPriceListByItemDocument = `
    mutation ImportItemPriceListByItem($importInput: ItemPriceListByItemImportInput!) {
  ImportItemPriceListByItem(importInput: $importInput) {
    success
    timestamp
    status
    message
    jobId
    detail
  }
}
    `;
export const useImportItemPriceListByItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportItemPriceListByItemMutation, TError, ImportItemPriceListByItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportItemPriceListByItemMutation, TError, ImportItemPriceListByItemMutationVariables, TContext>(
      ['ImportItemPriceListByItem'],
      (variables?: ImportItemPriceListByItemMutationVariables) => fetcher<ImportItemPriceListByItemMutation, ImportItemPriceListByItemMutationVariables>(client, ImportItemPriceListByItemDocument, variables, headers)(),
      options
    );
export const ItemPriceListCreateDocument = `
    mutation ItemPriceListCreate($data: ItemPriceListCreateInput!) {
  ItemPriceListCreate(data: $data) {
    id
    unique_id
    type
    name
    sales_channel_id
    sales_channel {
      id
      unique_id
      name_en
      name_th
    }
    is_increase
    currency
    description
    is_active
    start_date
    end_date
    adjusted_price
    adjusted_item_list {
      id
      sku_name
      item_name
      reference_unique_id
      current_price
      adjusted_price
    }
  }
}
    `;
export const useItemPriceListCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemPriceListCreateMutation, TError, ItemPriceListCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemPriceListCreateMutation, TError, ItemPriceListCreateMutationVariables, TContext>(
      ['ItemPriceListCreate'],
      (variables?: ItemPriceListCreateMutationVariables) => fetcher<ItemPriceListCreateMutation, ItemPriceListCreateMutationVariables>(client, ItemPriceListCreateDocument, variables, headers)(),
      options
    );
export const ItemPriceListDeleteDocument = `
    mutation ItemPriceListDelete($uniqueInput: ItemPriceListUniqueInput!) {
  ItemPriceListDelete(uniqueInput: $uniqueInput) {
    id
    unique_id
    name
  }
}
    `;
export const useItemPriceListDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemPriceListDeleteMutation, TError, ItemPriceListDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemPriceListDeleteMutation, TError, ItemPriceListDeleteMutationVariables, TContext>(
      ['ItemPriceListDelete'],
      (variables?: ItemPriceListDeleteMutationVariables) => fetcher<ItemPriceListDeleteMutation, ItemPriceListDeleteMutationVariables>(client, ItemPriceListDeleteDocument, variables, headers)(),
      options
    );
export const ItemPriceListFindUniqueDocument = `
    query ItemPriceListFindUnique($uniqueInput: ItemPriceListUniqueInput!) {
  ItemPriceListFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    type
    name
    sales_channel_id
    sales_channel {
      name_th
      id
      name_en
      unique_id
    }
    is_increase
    currency
    description
    is_active
    start_date
    end_date
    adjusted_price
    adjusted_item_list {
      id
      sku_name
      item_name
      reference_unique_id
      current_price
      adjusted_price
    }
  }
}
    `;
export const useItemPriceListFindUniqueQuery = <
      TData = ItemPriceListFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemPriceListFindUniqueQueryVariables,
      options?: UseQueryOptions<ItemPriceListFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemPriceListFindUniqueQuery, TError, TData>(
      ['ItemPriceListFindUnique', variables],
      fetcher<ItemPriceListFindUniqueQuery, ItemPriceListFindUniqueQueryVariables>(client, ItemPriceListFindUniqueDocument, variables, headers),
      options
    );
export const ItemPriceListFindAllDocument = `
    query ItemPriceListFindAll($filterInput: ItemPriceListFindAllInput) {
  ItemPriceListFindAll(filterInput: $filterInput) {
    id
    unique_id
    type
    name
    is_increase
    currency
    description
    is_active
    start_date
    end_date
    adjusted_price
    adjusted_item_list {
      id
      sku_name
      item_name
      reference_unique_id
      current_price
      adjusted_price
    }
    sales_channel_id
  }
}
    `;
export const useItemPriceListFindAllQuery = <
      TData = ItemPriceListFindAllQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemPriceListFindAllQueryVariables,
      options?: UseQueryOptions<ItemPriceListFindAllQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemPriceListFindAllQuery, TError, TData>(
      variables === undefined ? ['ItemPriceListFindAll'] : ['ItemPriceListFindAll', variables],
      fetcher<ItemPriceListFindAllQuery, ItemPriceListFindAllQueryVariables>(client, ItemPriceListFindAllDocument, variables, headers),
      options
    );
export const ItemPriceListUpdateDocument = `
    mutation ItemPriceListUpdate($uniqueInput: ItemPriceListUniqueInput!, $data: ItemPriceListUpdateInput!) {
  ItemPriceListUpdate(uniqueInput: $uniqueInput, data: $data) {
    id
    unique_id
    type
    name
    sales_channel_id
    sales_channel {
      id
      unique_id
      name_en
      name_th
    }
    is_increase
    currency
    description
    is_active
    start_date
    end_date
    adjusted_price
    adjusted_item_list {
      id
      sku_name
      item_name
      reference_unique_id
      current_price
      adjusted_price
    }
  }
}
    `;
export const useItemPriceListUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemPriceListUpdateMutation, TError, ItemPriceListUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemPriceListUpdateMutation, TError, ItemPriceListUpdateMutationVariables, TContext>(
      ['ItemPriceListUpdate'],
      (variables?: ItemPriceListUpdateMutationVariables) => fetcher<ItemPriceListUpdateMutation, ItemPriceListUpdateMutationVariables>(client, ItemPriceListUpdateDocument, variables, headers)(),
      options
    );
export const TraceEntriesFindManyAggridDocument = `
    query TraceEntriesFindManyAggrid($aggridInput: AggridTemplateInput) {
  TraceEntriesFindManyAggrid(aggridInput: $aggridInput) {
    results {
      unique_id
      reference_unique_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
      is_stockable
      type
      item_unique_id
      sku_name
      item_name
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      uom_id
      uom {
        unique_id
        id
        name_th
      }
      cost_price
      discount
      additional_cost
      remark
      posted_date
      created_date
      lot_date
      manufactured_date
      expired_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      tracability
      barcode
      stock_qty
      serial_no
      status
      scanned_by
      destination_scanned_by
      destination_scanned_date
    }
    count
  }
}
    `;
export const useTraceEntriesFindManyAggridQuery = <
      TData = TraceEntriesFindManyAggridQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: TraceEntriesFindManyAggridQueryVariables,
      options?: UseQueryOptions<TraceEntriesFindManyAggridQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TraceEntriesFindManyAggridQuery, TError, TData>(
      variables === undefined ? ['TraceEntriesFindManyAggrid'] : ['TraceEntriesFindManyAggrid', variables],
      fetcher<TraceEntriesFindManyAggridQuery, TraceEntriesFindManyAggridQueryVariables>(client, TraceEntriesFindManyAggridDocument, variables, headers),
      options
    );
export const WmsUniqueIdGenerateDocument = `
    query WmsUniqueIdGenerate($modelType: WmsModelType!) {
  UniqueIdGenerate(modelType: $modelType)
}
    `;
export const useWmsUniqueIdGenerateQuery = <
      TData = WmsUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: WmsUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<WmsUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<WmsUniqueIdGenerateQuery, TError, TData>(
      ['WmsUniqueIdGenerate', variables],
      fetcher<WmsUniqueIdGenerateQuery, WmsUniqueIdGenerateQueryVariables>(client, WmsUniqueIdGenerateDocument, variables, headers),
      options
    );
export const GoodsReturnCreateDocument = `
    mutation GoodsReturnCreate($createInput: GoodsReturnCreateInput!) {
  GoodsReturnCreate(createInput: $createInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      po_reference_unique_id
      expired_date
      manufactured_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    remark
  }
}
    `;
export const useGoodsReturnCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReturnCreateMutation, TError, GoodsReturnCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReturnCreateMutation, TError, GoodsReturnCreateMutationVariables, TContext>(
      ['GoodsReturnCreate'],
      (variables?: GoodsReturnCreateMutationVariables) => fetcher<GoodsReturnCreateMutation, GoodsReturnCreateMutationVariables>(client, GoodsReturnCreateDocument, variables, headers)(),
      options
    );
export const GoodsReturnDocument = `
    query GoodsReturn($uniqueInput: GoodsReturnWhereUniqueInput) {
  GoodsReturn(uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      po_reference_unique_id
      expired_date
      manufactured_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    remark
  }
}
    `;
export const useGoodsReturnQuery = <
      TData = GoodsReturnQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsReturnQueryVariables,
      options?: UseQueryOptions<GoodsReturnQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsReturnQuery, TError, TData>(
      variables === undefined ? ['GoodsReturn'] : ['GoodsReturn', variables],
      fetcher<GoodsReturnQuery, GoodsReturnQueryVariables>(client, GoodsReturnDocument, variables, headers),
      options
    );
export const GoodsReturnUpdateDocument = `
    mutation GoodsReturnUpdate($updateInput: GoodsReturnUpdateInput!, $uniqueInput: GoodsReturnWhereUniqueInput!) {
  GoodsReturnUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    created_by {
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_date
    posted_date
    reference_unique_id
    trace_entry_list {
      sku_name
      unique_id
      type
      item_unique_id
      item_img_url
      item_name
      qty
      document_item_qty
      posted_qty
      uom_id
      uom {
        id
        name_th
        unique_id
      }
      cost_price
      discount
      additional_cost
      remark
      created_date
      posted_date
      lot_date
      source_bin_location_id
      source_bin_location {
        name
        id
      }
      tracability
      barcode
      status
      serial_no
      scanned_by
      expired_date
      is_stockable
      po_reference_unique_id
      expired_date
      manufactured_date
      reference_unique_id
    }
    branch_id
    branch {
      name
      status
      unique_id
      is_hq
    }
    warehouse_id
    warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    sub_status
    flag_status
    aggrid_status
    remark
  }
}
    `;
export const useGoodsReturnUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReturnUpdateMutation, TError, GoodsReturnUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReturnUpdateMutation, TError, GoodsReturnUpdateMutationVariables, TContext>(
      ['GoodsReturnUpdate'],
      (variables?: GoodsReturnUpdateMutationVariables) => fetcher<GoodsReturnUpdateMutation, GoodsReturnUpdateMutationVariables>(client, GoodsReturnUpdateDocument, variables, headers)(),
      options
    );